import React, {Component} from "react";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import {withRouter} from "react-router";
import styles from "./Event.module.scss";
import mapLockImg from "../../components/assets/map-locked.svg";
import mapUnlockImg from "../../components/assets/map-unlocked.svg";
import settingsInactive from "../../components/assets/map-settings-inactive.svg";
import settingsActive from "../../components/assets/map-settings-active.svg";
import mapClose from "../../components/assets/map-close.svg";
import mapExpand from "../../components/assets/map-expand.svg";
import WebMercatorViewport from "@math.gl/web-mercator";
import "mapbox-gl/dist/mapbox-gl.css";
import AuthenticationService from "../../services/authenticationService";
import cookieService from "../../services/cookieService";
import authProviderConfig from "../../config/authProviderConfig";
import mapService from "../../services/mapService";
import geolocationService from "../../services/geolocationService";
import {ThemeContext} from "../../Context/ThemeContext";
import safeLocalStorageService from "../../services/useSafeLocalStorage";
import {BottomSheet} from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import {
  restServiceGet,
  restServicePost,
  restServicePut,
} from "../../utils/rest";

import {
  MAPBOX_TOKEN,
  MAPTILER_PATH_WITH_TOKEN,
  MOBILE_VIEW_THRESHOLD,
  DESKTOP_JOURNEY_MAP_WIDTH_GAP,
  MOBILE_MAP_HEIGHT_GAP,
} from "./../../domain/constants";
import {
  destinationError,
  travelPlanError,
  journeyPlanError,
  mercatorError,
} from "./../../domain/constants/error";
import {library} from "@fortawesome/fontawesome-svg-core";
import {fas} from "@fortawesome/free-solid-svg-icons";
import userLocalDataService from "./../../services/data/userLocalDataService";
import authLocalDataService from "./../../services/data/authLocalDataService";
import DisruptionsModal from "../../components/common/DisruptionsModal";
import {Marker, Source, Layer, Popup} from "react-map-gl";
import EditJourney from "../../components/EditJourney/";
import Footer from "../../components/common/Footer";
// import Cluster from "react-map-gl-cluster";
import JourneyCollection from "../../components/JourneyCollection";
import JourneyLoadingMessages from "../../components/JourneyLoadingMessages";
import Loading from "../../components/common/Loading";

import ReactMapGL from "react-map-gl";
import maplibregl from "maplibre-gl";
import ClusterTrafficMarker from "../../components/MapMarkers/ClusterTrafficMarker";
import CurrentLocation from "../../components/common/CurrentLocation";
import Walk from "../../components/assets/round-directions_walk.png";
import Ferry from "../../components/assets/round-directions_boat.png";
import CableCar from "../../components/assets/cableCar.png";
import Rail from "../../components/assets/round-directions_railway.png";
import Bus from "../../components/assets/round-directions_bus.png";
import Tram from "../../components/assets/round-tram.png";
import Underground from "../../components/assets/round-directions_subway.png";
import Drive from "../../components/assets/round-directions_car.png";
import Park from "../../components/assets/round-local_parking.png";
import EvStation from "../../components/assets/round-ev_station.png";
import Cycle from "../../components/assets/round-local_cycle.png";
import CycleDock from "../../components/assets/cycle_hire_map_icon.svg";
import Flight from "../../components/assets/round-flight-24px.svg";
import {ReactComponent as LocationOn} from "../../components/assets/round-location_on-24px.svg";
import ErrorBoundary from "../../components/common/Error/ErrorBoundary";
import InitialLoadingMessages from "../../components/InitialLoadingMessages";
import RedirectionPopup from "../../components/common/RedirectionPopup";
import InfoPopup from "../../components/common/InfoPopup";
import RequestAssistance from "../../components/common/RequestAssistance";
import AddNotification from "../../components/AddNotification";
import Confirmation from "../../components/common/Confirmation";
import Profile from "../../components/common/Profile";
import Error from "../../components/common/Error/Error";
import Sharing from "../../components/common/Sharing";
import Menu from "../../components/common/Menu";
import MapMarkerPopup from "../../components/MapMarkers/MapMarkerPopup";
import MapMarkerTrafficPopup from "../../components/MapMarkers/MapMarkerTrafficPopup";
import CrossSiteWarning from "../../components/common/CrossSiteWarning";
import {defaultFilters} from "../../domain/constants/filters";
import MarkerGroups from "../../components/MarkerGroups";
import ClusterHandler from "../../components/MarkerGroups/ClusterHandler";
import TrafficClusterGroup from "../../components/MarkerGroups/TrafficClusterGroup";
import SessionManagement from "../../components/common/SessionManagement";
import {parseAndValidateLngLat} from "../../utils/geo";

library.add(fas);

const authenticationService = new AuthenticationService(authProviderConfig);

// Lazy loaded components
// const ReactMapGL = loadable( () => import( "@urbica/react-map-gl" ) );

// const FontAwesomeIcon = loadable(() => import("@fortawesome/react-fontawesome"), {
//   resolveComponent: (components) => components.FontAwesomeIcon,
// });

class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPosition: {latitude: 0, longitude: 0, timestamp: 0},
      lastScrollTop: 0,
      searched: false,
      showResults: false,
      showLoading: true,
      showInitialLoading: false,
      showLoadingJourneyMessages: false,
      showForm: false,
      showVia1: false,
      showConfirmation: false,
      isEvDestinationGroup: false,
      isPTOptions: false,
      isAssistanceConfirmation: false,
      ConfirmedAssistance: false,
      showPendingAssistance: false,
      journeys: {},
      returnJourneys: null,
      selectedJourneyOption: null,
      selectedReturnJourneyOption: null,
      activeLeg: null,
      activeJourney: 0,
      activeReturnJourney: 0,
      activeJourneyLegs: null,
      activeReturnJourneyLegs: null,
      sharing: false,
      travelPlanID: null,
      updateMap: 0,
      journeyPlanId: null,
      returnJourneyPlanId: null,
      profile: false,
      disruptionMessages: [],
      menu: false,
      requestAssistance: false,
      travelForecastId: null,
      profileInfo: null,
      profilefilter: {
        ...defaultFilters,
      },
      lineDatas: [],
      assistanceSettings: {
        isCurrentLocationShared: false,
        isTravelPlanShared: false,
        contacts: [
          {
            email: null,
            name: null,
            phone: null,
            status: null,
          },
        ],
      },
      assistanceRequestData: null,
      previousTravelPlans: null,
      pastTravelPlans: null,
      usrid: null,
      mapFocusActived: true,
      uniqueuserid: null,
      profileId: null,
      isMultiDestination: false,
      isEnableLocation: true,
      isEnableNavigation: true,
      autoCompleteParams: null,
      destinationGroupShortCode: null,
      showTravelPlan: false,
      travelForecast: null,
      filters: null,
      legs: [],
      isItineraryActive: false,
      singleNonMDDestinationEvent: null,
      trafficData: [],
      locationDropDownOpen: false,
      activeDestinationEvent: "",
      destinationEvents: [],
      viewport: {
        latitude: 0,
        longitude: 0,
      },
      viewportMarker: null,
      mapBounds: {},
      setViewport: false,
      width: window.innerWidth,
      markerPopup: true,
      customMapURL: null,
      eventSelectedOnMap: null,
      mapRegion: null,
      lastLat: null,
      lastLong: null,
      language: "en",
      languageFromUrl: false,
      isCrossSiteChecked: false,
      crossSite: null,
      showCrossSiteWarning: false,
      defaultFrom: null,
      defaultTo: null,
      disableGoogleSuggestionList: false,
      mapNotReadyToRender: true,
      boundingBox: null,
      journeyPlanButtonTxt: "",
      consentStatement: "",
      itineraryEnabled: false,
      displayDisruptionsModal: false,
      showEVCluster: false,
      clusteringEnabled: true,
      clusteringFunctionalityEnabled: false,
      groupName: "",
      thirdPartyLogin: "",
      thirdPartyAuthenticated: false,
      thirdPartyData: "",
      mapLocked: false,
      isPrioritizedPopUp: false,
      publicTransportationOptions: {
        filterBus: true,
        filterTram: true,
        filterTrain: true,
      },
      markerOptions: [
        {
          markerId: "",
          destinationGroupShortCode: "",
          initialDisplay: false,
          marker: {
            id: "",
            name: "",
            type: "",
            color: "",
            icon: "",
            keyIcon: "",
            keyDisplayName: "",
            description: "",
            size: "",
          },
          isFocused: false,
        },
      ],
      showMarkerModal: false,
      showDirectionsModal: false,
      showIntermediateStops: false,
      isIntermediateStopsVisible: true,
      fullscreen: false,
      errorMapLoad: false,
      error: false,
      errorType: null,
      errormessage: null,
      departureTime: null,
      arrivalTime: null,
      returnDepartureTime: null,
      returnArrivalTime: null,
      selectedDateTime: null,
      selectedReturnDateTime: null,
      destinationGroupName: null,
      destinationGroupId: null,
      destinationGroup: null,
      destinationGroupAssistanceContacts: [],
      organisationId: null,
      organisation: {
        id: "",
        name: "",
        notificationAutomaticApproval: "",
        desktopFooter: {
          heading: "",
          footerValues: [],
        },
        mobileFooter: {
          heading: "",
          footerValues: [],
        },
      },
      thirdPartyPopUp: false,
      thirdPartyRedirectionURL: null,
      thirdPartyJourneyDetails: null,
      showAssistantInformation: true,
      initOperations: false,
      infoPopup: false,
      infoContent: "",
      trafficForecast: false,
      isTrafficForecastAvailable: false,
      showPolyPopUp: false,
      PolyPopUp: {},
      isCheckForUpdate: false,
      destinationLocation: null,
      originLocation: null,
      editProfile: false,
      terminateLegAnimation: false,
      selectedLegIndex: null,
      autoCompleteCustomPlaces: [],
      alertsButtonDisabled: true,
      hideEditJourneyButtons: true,
      showReturn: false,
      isReturn: false,
      headerMapVerticalOffset: false,
      unsecureUserPosition: null,
      isUserWayActive: false,
      triggerStartLocationRefresh: false,
      triggerDateTimeRefresh: false,
      activeModal: null,
      showBottomSheet: true,
      // Gate rendering of map Sources/Layers until the map style is fully loaded
      styleLoaded: false,
    };

    this._clusterTraffic = React.createRef();
    this.bottomSheetRef = React.createRef();
    this.onClickTrafficCluster = this.onClickTrafficCluster.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
  }

  // Safe setState wrapper that checks if component is mounted
  safeSetState = (...args) => {
    if (this._isMounted) {
      this.setState(...args);
    }
  };

  static contextType = ThemeContext;

  // ensure Mapbox canvas and all map controls (attribution links, zoom, etc.) are skipped in tab order
  setMapCanvasUntabbable = () => {
    try {
      if (!this.reactMap || !this.reactMap.getMap) return;
      const map = this.reactMap.getMap();
      if (!map || !map.getCanvas) return;
      const canvas = map.getCanvas();
      if (canvas) canvas.setAttribute("tabindex", "-1");

      // Also remove tab-stops from all focusable elements inside the map container (attribution links, buttons, etc.)
      const container = map.getContainer && map.getContainer();
      if (container) {
        const focusables = container.querySelectorAll(
          'a, button, [tabindex]:not([tabindex="-1"])'
        );
        focusables.forEach((el) => {
          if (el !== canvas) el.setAttribute("tabindex", "-1");
        });
      }
    } catch (_) {
      // do nothing
    }
  };

  setShowReturn = (shouldShow) => {
    this.setState({
      showReturn: shouldShow,
      markerPopup: false,
      originLocation: this.state.destinationLocation,
      destinationLocation: this.state.originLocation,
    });
  };

  setIsReturn = (newValue) => {
    this.setState((prevState) => {
      if (prevState.isReturn !== newValue) {
        return {isReturn: newValue};
      }
      return null;
    });
  };

  clearReturnJourneys = () => {
    this.setState({
      returnJourneys: null,
      activeReturnJourney: 0,
      activeReturnJourneyLegs: null,
      returnJourneyPlanId: null,
      selectedReturnJourney: null,
      returnJourneyOptionId: null,
      showReturn: false,
    });
  };

  setSelectedLegIndex = (newIndex) => {
    this.setState({selectedLegIndex: newIndex});
  };

  setAlertsButton = (value) => {
    this.setState({alertsButtonDisabled: value});
  };

  setTerminateLegAnimation = (shouldTerminateLegAnimation) => {
    this.setState({terminateLegAnimation: shouldTerminateLegAnimation});
  };

  closeCrossSiteWarning = () => {
    this.setState({showCrossSiteWarning: false});
  };

  onViewportChange(viewport) {
    this.setState({viewport});
  }

  setViewport = (latitude, longitude, zoom) => {
    // Use imperative API to move the map (since we're using uncontrolled mode)
    try {
      const map = this.reactMap?.getMap?.();
      if (map) {
        map.flyTo({
          center: [longitude, latitude],
          zoom: zoom,
          duration: 800,
        });
      }
    } catch (e) {
      console.error("Error moving map in setViewport:", e);
    }

    // Update state for tracking
    this.setState({
      viewport: {
        latitude,
        longitude,
        zoom,
      },
    });
  };

  setViewportAndMarker = (latitude, longitude, zoom) => {
    // Use imperative API to move the map (since we're using uncontrolled mode)
    try {
      const map = this.reactMap?.getMap?.();
      if (map) {
        map.flyTo({
          center: [longitude, latitude],
          zoom: zoom,
          duration: 800,
        });
      }
    } catch (e) {
      console.error("Error moving map in setViewportAndMarker:", e);
    }

    // Update state for tracking and marker display
    this.setState({
      viewport: {
        latitude,
        longitude,
        zoom,
      },
      viewportMarker: {
        latitude,
        longitude,
      },
    });
  };

  onClickCluster = (clusterViewport) => {
    // Smoothly animate to the cluster's position/zoom instead of snapping
    try {
      const map = this.reactMap?.getMap?.();
      if (map && clusterViewport) {
        const {longitude, latitude, zoom} = clusterViewport;
        map.flyTo({
          center: [longitude, latitude],
          zoom: typeof zoom === "number" ? zoom : map.getZoom(),
          duration: 800,
        });
        this.setState({activeDestinationEvent: ""});
        return;
      }
    } catch (_) { }

    // Fallback: direct state update (no animation)
    this.setState((state) => ({
      ...state,
      viewport: {...state.viewport, ...clusterViewport},
      activeDestinationEvent: "",
    }));
  };

  //TODO: Fold in
  onClickTrafficCluster(cluster) {
    const {clusterId, longitude, latitude} = cluster;

    const supercluster = this._clusterTraffic.current.getCluster();
    const zoom = supercluster.getClusterExpansionZoom(clusterId);
    try {
      const map = this.reactMap?.getMap?.();
      if (map) {
        map.flyTo({center: [longitude, latitude], zoom, duration: 800});
        this.setState({activeDestinationEvent: ""});
        return;
      }
    } catch (_) { }

    // Fallback without animation
    this.setState((state) => ({
      ...state,
      viewport: {...state.viewport, latitude, longitude, zoom},
      activeDestinationEvent: "",
    }));
  }

  crossSiteValidationOperation = () => {
    cookieService.setCookie("checkCrossSite", "enabled", 1);
    var checkCrossSiteValue = cookieService.getCookie("checkCrossSite");

    this.setState({
      isCrossSiteChecked: true,
      crossSite: checkCrossSiteValue,
    });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    // NEVER call setState in shouldComponentUpdate - moved all that logic to componentDidUpdate

    if (this.reactMap !== undefined && this.reactMap !== null) {
      const map = this.reactMap.getMap();
      if (this.state.fullscreen === nextState.fullscreen) {
        map.resize();
      }

      if (this.state.mapLocked !== nextState.mapLocked) {
        const isMobile = this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD;
        if (nextState.mapLocked || isMobile) {
          map.scrollZoom.disable();
          map.dragPan.disable();
        } else {
          map.scrollZoom.enable();
          map.dragPan.enable();
        }
      }
    }

    return true;
  };

  speed = (bitsPerSecond) => {
    const bytesInAKilobyte = 1024;
    var KBps = (bitsPerSecond / bytesInAKilobyte).toFixed(2);
    if (KBps <= 1) return {value: bitsPerSecond, units: "Bps"};
    var MBps = (KBps / bytesInAKilobyte).toFixed(2);
    if (MBps <= 1) return {value: KBps, units: "KBps"};
    else return {value: MBps, units: "MBps"};
  };

  updateUnsecureUserPosition = async () => {
    try {
      const position = geolocationService.getCurrentPosition();

      const userPosition = {
        LastUpdated: moment(position.timestamp).parseZone().format(),
        GeoPosition: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        },
      };

      this.setState({
        unsecureUserPosition: userPosition,
      });
    } catch (error) {
      // Handle error, e.g., user denied geolocation, etc.
    }
  };

  postUnsecureUserPosition = (journeyPlanId, userPosition) => {
    if (!journeyPlanId) return;
    restServicePost(
      this.props.apiToken,
      `updateUnsecureUserPosition/${journeyPlanId}`,
      userPosition
    )
      .then((response) => {
        // We don't care about the response.
      })
      .catch((err) => {
        console.warn("Error posting unsecure user position:", err);
      });
  };

  handleUnhandledRejection = (event) => {
    // This local handler is kept as a backup, but the main work is done in index.js
    const reason = event.reason;
    const isUnknown =
      reason === "Unknown promise rejection reason" ||
      (reason &&
        typeof reason === "object" &&
        reason.message === "Unknown promise rejection reason");

    if (reason === undefined || reason === null || isUnknown) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
  };

  componentDidMount = async () => {
    this._isMounted = true;

    // Initialize RTL plugin once on mount, if needed
    if (typeof window !== "undefined") {
      try {
        if (maplibregl.getRTLTextPluginStatus() === "unavailable") {
          maplibregl.setRTLTextPlugin(
            "https://cdn.maptiler.com/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
            null,
            true
          );
        }
      } catch (err) {
        console.warn("MapLibre RTL plugin failed to load", err);
      }
    }

    // Keep the Mapbox canvas out of the tab order
    this.setMapCanvasUntabbable();
    window.addEventListener("blur", this.onWindowBlur);

    geolocationService.startAutoPositionUpdate();

    // Methods used by Cypress tests
    if (window.Cypress) {
      window._expandBottomSheet = () => {
        this.bottomSheetRef.current?.snapTo(({snapPoints}) =>
          Math.max(...snapPoints)
        );
      };

      window._collapseBottomSheet = () => {
        this.bottomSheetRef.current?.snapTo(({snapPoints}) =>
          Math.min(...snapPoints)
        );
      };
    }

    const values = this.props.queryString;
    const fields = this.props.location.pathname.substring(1).split("/");
    const firstParam = fields[0];
    values.fields = fields;

    const searchParams = new URLSearchParams(window.location.search);
    const urlLanguage = searchParams.get("lang");

    const domainName = window.location.hostname;

    let shortCode = "global"; // Set a default value for shortCode

    if (firstParam !== "" && firstParam !== "journeyplan") {
      shortCode = firstParam;
    }

    console.log("ShortCode: " + shortCode);

    const wasLoggingIn = safeLocalStorageService.getItem("isLoggingIn");
    const latestJourneyPlanId = safeLocalStorageService.getItem(
      "latestJourneyPlanId"
    );
    const latestJourneyOptionId = safeLocalStorageService.getItem(
      "latestJourneyOptionId"
    );

    safeLocalStorageService.removeItem("isLoggingIn");
    safeLocalStorageService.removeItem("latestJourneyPlanId");
    safeLocalStorageService.removeItem("latestJourneyOptionId");
    safeLocalStorageService.removeItem("customerId");

    // If the user is returning from the login flow, reload the journey plan they were doing
    if (
      wasLoggingIn &&
      latestJourneyPlanId &&
      latestJourneyOptionId &&
      this.props.auth.isAuthenticated()
    ) {
      this.getJourneyPlanResponse(
        latestJourneyPlanId,
        latestJourneyOptionId,
        shortCode
      );
    }

    if (values.customerId) {
      safeLocalStorageService.setItem("customerId", values.customerId);
    }

    await restServiceGet(this.props.apiToken, "domainSettings/" + domainName)
      .then((domainResponse) => {
        if (
          domainResponse.data !== null &&
          domainResponse.data !== undefined &&
          domainResponse.data !== ""
        ) {
          shortCode = domainResponse.data.destinationGroupCode;
          if (domainResponse.data.theme) {
            document.documentElement.style.setProperty(
              "--main-font-family",
              domainResponse.data.theme.fontFamily || ""
            );
            if (domainResponse.data.theme.siteTitle) {
              document.title = domainResponse.data.theme.siteTitle;
            }
            if (domainResponse?.data?.theme.isHeaderEnabled) {
              document.documentElement.style.setProperty(
                "--header-top-padding",
                "42px"
              );
            }

            const {setTheme} = this.context;
            setTheme(domainResponse.data.theme);
          }
          safeLocalStorageService.setItem(
            "callbackURL",
            domainResponse.data.callbackURL
          );
          safeLocalStorageService.setItem(
            "logoutRedirectURL",
            domainResponse.data.logoutRedirectURL
          );
        } else {
          safeLocalStorageService.removeItem("callbackURL");
          safeLocalStorageService.removeItem("logoutRedirectURL");
        }
        restServiceGet(
          this.props.apiToken,
          "organisationByDestinationGroup/" + shortCode
        )
          .then((organisationResponse) => {
            console.log("Organisation Object: ", organisationResponse.data);

            this.applyOrganisationSettings(organisationResponse.data, true);
          })
          .catch((error) => {
            console.log(error);
            this.setState({
              organisation: null,
            });
          });
      })
      .catch((error) => {
        console.log(error);
      });

    const istfgm = fields[0] === "bee_network";

    if (!istfgm && urlLanguage) {
      this.props.contextWrapper.selectLanguage(urlLanguage);
      this.setState({
        languageFromUrl: true,
        language: urlLanguage,
      });
    }

    if (firstParam === "callback") return;

    if (firstParam === "logout")
      window.location.href = safeLocalStorageService.getItem("base_Url");

    try {
      if (!istfgm) {
        if (!this.props.auth.isAuthenticated()) {
          safeLocalStorageService.clear();
        } else {
          this.createInitialUserIdentity();
        }
      }
    } catch (err) {
      console.log(err.message);
    }
    // Authentication result is fetched from get travel plan button NOT ACTIVE
    if (
      authLocalDataService.getAPIMUser() !== null &&
      safeLocalStorageService.getItem("travelForecast") !== null
    ) {
      var apimUser = authLocalDataService.getAPIMUser();
      var travelForecast = safeLocalStorageService.getItem("travelForecast");
      this.updateUserPosition();
      this.postUser(
        apimUser,
        JSON.parse(travelForecast),
        safeLocalStorageService.getItem("journeyOptionId"),
        safeLocalStorageService.getItem("destinationName"),
        false
      );
      this.setState({
        destinationGroupShortCode: this.props.location.pathname.substring(1),
      });
    } else if (values.travelplanid) {
      this.getTravelPlan(
        values.travelplanid,
        values.checkforupdates,
        values.assist
      );
    } else if (values.journeyplanid && values.journeyoptionid) {
      this.getJourneyPlanResponse(
        values.journeyplanid,
        values.journeyoptionid,
        firstParam
      );
      if (values.journeyplanid) {
        this.postUnsecureUserPosition(values.journeyplanid, {
          ...this.state.unsecureUserPosition,
          RequestSent: moment.parseZone().format(),
        });
      }
    } else if (values.userId) {
      this.toggleAssistanceConfirmation(values.userId);
    } else {
      this.setState({destinationEvents: []});
      if (shortCode === "global") {
        axios
          .get("https://geolocation-db.com/json/", {timeout: 5000})
          .then((response) => {
            let ip = response.data.IPv4;
            this.getDestinationGroups(shortCode, values, ip);
          })
          .catch((error) => {
            console.error(
              "Failed to get user location from https://geolocation-db.com/json/. Using default values.",
              error.message
            );
            this.getDestinationGroups(shortCode, values, "default");
          });
      } else {
        this.getDestinationGroups(shortCode, values);
      }
    }

    try {
      safeLocalStorageService.removeItem("travelForecast");
      safeLocalStorageService.removeItem("journeyOptionId");
      safeLocalStorageService.removeItem("journeyPlanId");
      safeLocalStorageService.removeItem("destinationName");
      safeLocalStorageService.removeItem("itineraryInputControl");
    } catch (err) {
      console.log(err.message);
    }

    window.addEventListener("resize", this.updateDimensions);

    this.getProfileFilters();

    if (!istfgm) {
      var loggedIn = safeLocalStorageService.getItem("loggedIn");
      if (loggedIn === false) {
        if (this.props.auth.isAuthenticated()) {
          this.checkFirstLogin(!wasLoggingIn);
        }
      }
    }

    //show edit profile should be false by default on each component mount
    // this.setState({ editProfile: false });

    // Log network information here
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection ||
      null;

    var downloadSize = 1048576; //1Mb
    var bitsLoaded = downloadSize * 8;
    var duration = performance.now() / 1000;
    var speedBps = (bitsLoaded / duration).toFixed(2);
    var displaySpeed = this.speed(speedBps);

    const connectionType = connection ? connection.effectiveType : "unknown";
    const connectionDownlink = connection ? connection.downlink : 0;

    const data = {
      connectionType: connectionType,
      networkSpeed: connectionDownlink,
      pageLoadSpeed: performance.now(),
      userAgent: navigator.userAgent,
      internetSpeed: displaySpeed.value + "" + displaySpeed.units,
      speedBps: speedBps,
    };

    console.log("Network Information:", data);

    await this.updateUnsecureUserPosition();
  };

  applyOrganisationSettings = (organisationData, setHeaderOffset = false) => {
    if (!organisationData) return;

    // Apply theme settings
    if (organisationData.theme) {
      if (organisationData.theme.fontFamily) {
        document.documentElement.style.setProperty(
          "--main-font-family",
          organisationData.theme.fontFamily
        );
      }

      if (organisationData.theme.isHeaderEnabled) {
        document.documentElement.style.setProperty(
          "--header-top-padding",
          "42px"
        );

        if (setHeaderOffset) {
          this.setState({headerMapVerticalOffset: true});
        }
      }

      if (organisationData.theme.siteTitle) {
        document.title = organisationData.theme.siteTitle;
      }

      const mlbSettings = {
        showMlbHeaderFooter:
          organisationData.theme?.mlbSettings?.enabled || false,
        mlbTeam: organisationData.theme?.mlbSettings?.team || "mlb",
        mlbNoLinks: organisationData.theme?.mlbSettings?.noLinks || false,
      };
      if (mlbSettings.showMlbHeaderFooter) {
        this.props.updateMlbSettings(mlbSettings);
      }

      // Set theme in context
      const {setTheme} = this.context;
      setTheme(organisationData.theme);
    }

    // Hide elements on page if specified.
    if (organisationData.hideClientElements?.length > 0) {
      const {setHideClientElements} = this.context;
      setHideClientElements(organisationData.hideClientElements);
    }

    // Set getTravelForecast text if specified.
    if (organisationData.getTravelForecastText) {
      const {setGetTravelForecastText} = this.context;
      setGetTravelForecastText(organisationData.getTravelForecastText);
    }

    if (organisationData.expandPTOptionsModalComponent) {
      const {setExpandPTOptions} = this.context;
      setExpandPTOptions(organisationData.expandPTOptionsModalComponent);
    }

    if (organisationData.showReturnButton) {
      const {setShowReturnButton} = this.context;
      setShowReturnButton(organisationData.showReturnButton);
    }

    if (organisationData.carbonRemoval) {
      const {setCarbonRemovalValues} = this.context;
      setCarbonRemovalValues(organisationData.carbonRemoval);
    }

    const isPTOptions = organisationData.showPTOptionsModalComponent;

    this.setState({
      hideEditJourneyButtons: false,
      isPTOptions: isPTOptions,
      organisation: organisationData,
      isTrafficForecastAvailable:
        this.state.isTrafficForecastAvailable ||
        organisationData.isTrafficForecastAvailable,
    });
  };

  updateFavicon = (rel, href) => {
    let link =
      document.querySelector(`link[rel='${rel}']`) ||
      document.createElement("link");
    link.type = "image/png";
    link.rel = rel;
    link.href = `${href}?v=${new Date().getTime()}`; // Append a timestamp to force refresh
    document.head.appendChild(link);
  };

  toggleEditProfile = () => {
    this.setState({
      editProfile: !this.state.editProfile,
    });
  };

  toggleMarkerModal = () => {
    const {showMarkerModal} = this.state;
    this.setState({
      showMarkerModal: !showMarkerModal,
      activeModal: showMarkerModal ? null : "markerModal",
    });
    this.setShowBottomSheet(showMarkerModal);
  };

  toggleDirectionsModal = () => {
    const {showDirectionsModal} = this.state;
    this.setState({
      showDirectionsModal: !showDirectionsModal,
      activeModal: showDirectionsModal ? null : "directionsModal",
    });
    this.setShowBottomSheet(showDirectionsModal);
  };

  toggleIntermediateStopsModal = () => {
    const {showIntermediateStops} = this.state;
    this.setState({
      showIntermediateStops: !showIntermediateStops,
      activeModal: showIntermediateStops ? null : "intermediateStopsModal",
    });
    this.setShowBottomSheet(showIntermediateStops);
  };

  setActiveModal = (modalName) => {
    this.setState({activeModal: modalName});
  };

  toggleFullscreen = () => {
    const {fullscreen} = this.state;
    this.setState({fullscreen: !fullscreen});
  };

  onRegionChange(region, lastLat, lastLong) {
    this.setState({
      mapRegion: region,
      // If there are no new values set the current ones
      lastLat: lastLat || this.state.lastLat,
      lastLong: lastLong || this.state.lastLong,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener(
      "unhandledrejection",
      this.handleUnhandledRejection
    );
    clearTimeout(this._viewportTimeout);

    geolocationService.dispose();
    window.removeEventListener("blur", this.onWindowBlur);
    window.removeEventListener("resize", this.updateDimensions);
  }

  // re-apply skipping map tab after updates that may recreate the canvas
  componentDidUpdate(prevProps, prevState) {
    this.setMapCanvasUntabbable();

    // Handle assistance request viewport updates - USE IMPERATIVE API ONLY
    if (
      this.state.assistanceRequestData !== null &&
      prevState.assistanceRequestData !== null &&
      this.state.currentPosition !== undefined &&
      prevState.currentPosition.latitude !== this.state.currentPosition.latitude
    ) {
      const boundingbox = {
        maxLatitude: this.state.assistanceRequestData.assistedLatitude,
        maxLongitude: this.state.assistanceRequestData.assistedLongitude,
        minLatitude: this.state.currentPosition.latitude,
        minLongitude: this.state.currentPosition.longitude,
      };

      try {
        console.log("Assistance Request location logic - using imperative API");
        const map = this.reactMap?.getMap?.();
        if (map && map.fitBounds) {
          map.fitBounds(
            [
              [boundingbox.maxLongitude, boundingbox.maxLatitude],
              [boundingbox.minLongitude, boundingbox.minLatitude],
            ],
            {
              padding: 50,
              duration: 1000,
            }
          );
        }
      } catch (error) {
        console.log("Assistance Request bounding box failed", error);
      }
    }

    // Handle bounding box changes (journey results) - USE IMPERATIVE API ONLY
    if (
      prevState.boundingBox !== this.state.boundingBox &&
      this.state.boundingBox !== null &&
      this.refs.Map?.clientWidth
    ) {
      try {
        console.log(
          "componentDidUpdate: bounding box changed - using imperative API"
        );
        const map = this.reactMap?.getMap?.();
        if (map && map.fitBounds && this.state.boundingBox) {
          const bounds = this.state.boundingBox;
          map.fitBounds(
            [
              [bounds.maxLongitude, bounds.maxLatitude],
              [bounds.minLongitude, bounds.minLatitude],
            ],
            {
              padding:
                this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD ? 50 : 100,
              duration: 1000,
              maxZoom: bounds.maxZoomLevel || 19,
            }
          );
        }
      } catch (error) {
        console.log("Bounding box viewport update failed", error);
      }
    }

    // NO setState calls in componentDidUpdate - this causes infinite loops!
  }

  onWindowBlur = () => {
    this.setState({mapFocusActived: false});
  };

  getCurrentPosition = (changeViewport) => {
    function setCurrentPosition(location) {
      var latitude = location.coords.latitude;
      var longitude = location.coords.longitude;

      if (changeViewport) {
        this.setState({
          currentPosition: {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
            timestamp: location.timestamp,
          },
          setViewport: true,
          viewport: {
            latitude: latitude,
            longitude: longitude,
            zoom: 12,
          },
        });
      } else {
        this.setState({
          currentPosition: {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
            timestamp: location.timestamp,
            altitude: location.coords.altitude,
            altitudeAccuracy: location.coords.altitudeAccuracy,
          },
        });
      }
      this.sendCurrentPosition(location);
    }
    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          setCurrentPosition.bind(this),
          (err) => {
            console.warn("Geolocation error:", err);
          }
        );
      }
    } catch (e) {
      console.warn(
        "Error calling navigator.geolocation.getCurrentPosition:",
        e
      );
    }
  };

  authenticateThirdParty = (destinationGroupId) => {
    const token = new URLSearchParams(window.location.search).get("token");
    const _this = this;

    authenticationService.authenticate(
      destinationGroupId,
      token,
      (newState) => {
        _this.setState(newState);
      }
    );
  };

  getDestinationGroups = (shortCode, urlValues, ip = null) => {
    this.authenticateThirdParty(shortCode);

    let getViewport = false;
    let viewport;
    this.safeSetState({showLoading: true, errorMapLoad: false});

    restServiceGet(this.props.apiToken, "boundingbox/" + shortCode + "/")
      .then((response) => {
        getViewport = response.data.setViewport;
        if (getViewport) {
          /// TODO: Delete Log TA-2466

          console.log("get Bounding Box create viewPort");
          viewport = this.createViewPort(
            response.data.boundingBox,
            response.data.zoomLevel,
            response.data.maxZoomLevel,
            70,
            150,
            false
          );
          this.safeSetState({
            setViewport: getViewport,
            viewport: viewport,
            boundingBox: response.data.boundingBox,
          });
        }

        var params = [];

        if (ip) {
          params.push(`iPv4=${ip}`);
        }

        const currentLocation = geolocationService.getCurrentPosition();

        if (currentLocation) {
          params.push(`latitude=${currentLocation.latitude}`);
          params.push(`longitude=${currentLocation.longitude}`);
        }

        if (urlValues.categories?.[0]) {
          params.push(`categories=${urlValues.categories.split(",")}`);
          this.safeSetState({
            destinationGroupShortCode: urlValues.categories,
          });
        }

        if (urlValues.sourceIds?.[0]) {
          params.push(`sourceIds=${urlValues.sourceIds.split(",")}`);
          this.safeSetState({destinationGroupShortCode: urlValues.sourceIds});
        }
        //Used for Event Decision DGS
        else if (urlValues.q) {
          params.push(`sourceIds=${urlValues.q}`);
          this.safeSetState({destinationGroupShortCode: urlValues.q});
        } else if (
          urlValues.fields[1] !== undefined &&
          urlValues.fields[1] !== "journeyplan"
        ) {
          params.push(`sourceIds=${urlValues.fields[1]}`);
          shortCode = urlValues.fields[0];
          this.safeSetState({destinationGroupShortCode: urlValues.fields[1]});
        }
        if (urlValues.analyticsRestrictEvents?.[0]) {
          params.push(
            `analyticsRestrictEvents=${urlValues.analyticsRestrictEvents.split(
              ","
            )}`
          );
        }

        if (urlValues.analyticsRestrictDate?.[0]) {
          params.push(
            `analyticsRestrictDate=${urlValues.analyticsRestrictDate.split(
              ","
            )}`
          );
        }

        var url = `destinationgroup/${shortCode}/`;

        if (params.length > 0) {
          url = url + `?${params.join("&")}`;
        }

        const oktaId = this.getOktaId();
        if (oktaId) {
          const separator = params.length > 0 ? "&" : "?";
          url = url + `${separator}oktaId=${encodeURIComponent(oktaId)}`;
        }

        return restServiceGet(this.props.apiToken, url);
      })
      .then((response) => {
        // Set miles/kilometres.

        const isKilometres =
          response?.data?.destinationGroup?.isKilometres === true;
        if (isKilometres) {
          const {setIsKilometres} = this.context;
          setIsKilometres(true);
        }

        // Destination Type Logic
        let destinationGroup = null;
        let singleDestinationLocation = true;
        let isMultiDestination = false;

        // Default Suggestion Logic
        let defaultTo = null;
        let defaultFrom = null;
        let disableGoogleSuggestionList = false;

        let setViewport = false;
        let latitude = 0;
        let longitude = 0;
        let isclusteringEnabled = false;
        let isEnableNavigation = true;
        let autoCompleteParams = null;
        let isMapLocked = false;
        let isTrafficForecastAvailable = false;
        let destinationGroupId = null;
        let isEvDestinationGroup = false;
        let autoCompleteCustomPlaces = [];
        let isIntermediateStopsVisible = true;

        let destinationEvents = response.data.destinationEvents;

        destinationGroup = response.data.destinationGroup;

        destinationGroupId = destinationGroup.id;
        autoCompleteParams = destinationGroup.autoCompleteParams;
        singleDestinationLocation =
          destinationGroup.boundingBox.maxLongitude ===
            destinationGroup.boundingBox.minLongitude &&
            destinationGroup.boundingBox.maxLatitude ===
            destinationGroup.boundingBox.minLatitude
            ? true
            : false;

        isMultiDestination = destinationGroup.multiDestination;
        isclusteringEnabled = destinationGroup.clusteringEnabled;
        isMapLocked = destinationGroup.mapLocked;
        isTrafficForecastAvailable = destinationGroup.trafficForecastEnabled;
        isIntermediateStopsVisible =
          destinationGroup.intermediateStopsVisible !== undefined
            ? destinationGroup.intermediateStopsVisible
            : true;
        var defaultToDestinationId = destinationEvents.filter(
          (dest) =>
            dest.destinationId === urlValues.defaultTo ||
            dest.destinationId === urlValues.toEvent
        )?.[0]?.destinationId;
        defaultTo =
          defaultToDestinationId ?? destinationGroup?.defaultTo ?? defaultTo;
        var defaultFromDestinationId = destinationEvents.filter(
          (dest) =>
            dest.destinationId === urlValues.defaultFrom ||
            dest.destinationId === urlValues.fromEvent
        )?.[0]?.destinationId;
        defaultFrom =
          defaultFromDestinationId ??
          destinationGroup?.defaultFrom ??
          defaultFrom;

        disableGoogleSuggestionList =
          destinationGroup.disableGoogleSuggestionList !== undefined
            ? destinationGroup.disableGoogleSuggestionList
            : disableGoogleSuggestionList;
        autoCompleteCustomPlaces =
          destinationGroup.isCustomSuggestedListActive !== undefined
            ? destinationGroup.customPlaces
            : [];

        var enable = destinationGroup.enableNavigation;
        if (enable !== undefined) {
          isEnableNavigation = enable ? true : false;
        }

        if (
          destinationGroup.language !== undefined &&
          !this.state.languageFromUrl
        ) {
          this.props.contextWrapper.selectLanguage(destinationGroup.language);
        }

        isEvDestinationGroup =
          destinationGroup.journeyConfig &&
            destinationGroup.journeyConfig.journeyOrder
            ? destinationGroup.journeyConfig.journeyOrder.filter(
              (x) => x === 65
            ).length > 0
            : false;
        // Accessibility Logic
        if (destinationGroup.accessibilityToolEnabled) {
          this.handleAccessibility();
        }

        if (!getViewport) {
          var overrideZoomLevel = destinationGroup.zoomLevel;
          if (singleDestinationLocation && destinationEvents.length !== 0) {
            const location = destinationEvents.find(
              (el) => el.location !== undefined
            ).location;
            latitude = location.latitude;
            longitude = location.longitude;
            setViewport = true;
            viewport = {
              latitude: latitude,
              longitude: longitude,
              zoom: 12,
            };
          } else if (!isMultiDestination) {
            console.log("Creating single destination viewport...");

            viewport = this.createViewPort(
              destinationGroup.boundingBox,
              overrideZoomLevel,
              destinationGroup.maxZoomLevel,
              50,
              190,
              false
            );
            setViewport = true;
          } else if (isMultiDestination) {
            console.log("Creating multi-destination viewport...");
            viewport = this.createViewPort(
              destinationGroup.boundingBox,
              overrideZoomLevel,
              destinationGroup.maxZoomLevel,
              50,
              150,
              false
            );
            setViewport = true;
          } else {
            console.log("list of destinations create viewport");

            const location = destinationEvents.find(
              (el) => el.location !== undefined
            ).location;
            latitude =
              (this.state.currentPosition &&
                this.state.currentPosition.latitude) ||
              location.latitude;
            longitude =
              (this.state.currentPosition &&
                this.state.currentPosition.longitude) ||
              location.longitude;

            viewport = this.createViewPort(
              destinationGroup.boundingBox,
              overrideZoomLevel,
              destinationGroup.maxZoomLevel,
              50,
              150,
              false
            );
            setViewport = true;
          }
        }

        // TODO: Separate this out into it's own function/logic.
        if (
          urlValues.longitude &&
          urlValues.latitude &&
          parseFloat(urlValues.longitude) &&
          parseFloat(urlValues.latitude)
        ) {
          const defaultZoom = 12;
          viewport = {
            latitude: urlValues.latitude,
            longitude: urlValues.longitude,
            zoom:
              urlValues.zoom && parseInt(urlValues.zoom)
                ? urlValues.zoom
                : defaultZoom,
          };
          setViewport = true;
        }

        if (
          defaultFrom === "currentlocation" ||
          defaultTo === "currentlocation"
        ) {
          this.getCurrentPosition(true);
        } else {
          //Check if permissions have already been granted, and if they have, display the users current position anyway
          const displayLocationIfPermissionGiven = async () => {
            try {
              if (navigator.permissions && navigator.permissions.query) {
                const permissionStatus = await navigator.permissions.query({
                  name: "geolocation",
                });
                if (permissionStatus.state === "granted") {
                  // Ensure this call doesn't throw unhandled errors
                  try {
                    this.getCurrentPosition(false);
                  } catch (e) {
                    console.warn("Error getting current position:", e);
                  }
                }
              }
            } catch (error) {
              console.warn("Error checking geolocation permissions:", error);
            }
          };
          displayLocationIfPermissionGiven();
        }

        var object = {
          destinationGroupShortCode: shortCode,
          setViewport: getViewport ? getViewport : setViewport,
          viewport: viewport,
          isEvDestinationGroup: isEvDestinationGroup,
          isMultiDestination: isMultiDestination,
          clusteringEnabled: isclusteringEnabled,
          isEnableNavigation: isEnableNavigation,
          isIntermediateStopsVisible: isIntermediateStopsVisible,
          customMapURL: destinationGroup.customMapURL,
          defaultFrom: defaultFrom,
          defaultTo: defaultTo,
          disableGoogleSuggestionList: disableGoogleSuggestionList,
          journeyPlanButtonTxt: destinationGroup.travelplanbutntxt,
          consentStatement: destinationGroup.consentstatement,
          itineraryEnabled: destinationGroup.itineraryenabled,
          autoCompleteParams: autoCompleteParams,
          mapLocked: isMapLocked,
          isTrafficForecastAvailable: isTrafficForecastAvailable,
          autoCompleteCustomPlaces: autoCompleteCustomPlaces,
          markerOptions: destinationGroup.markerOptions,
          organisationId: destinationGroup.organisationId,
          destinationGroup: destinationGroup,
          destinationGroupId: destinationGroupId,
          destinationGroupAssistanceSettings:
            destinationGroup.assistanceSettings,
          destinationGroupName: destinationGroup.name,
        };

        if (
          destinationGroup.organisationId !== undefined &&
          destinationGroup.organisationId !== null
        ) {
          restServiceGet(
            this.props.apiToken,
            "organisation/" + destinationGroup.organisationId
          )
            .then((organisationResponse) => {
              // Hide elements on page if specified.
              if (organisationResponse?.data?.hideClientElements?.length > 0) {
                const {setHideClientElements} = this.context;
                setHideClientElements(
                  organisationResponse?.data?.hideClientElements
                );
              }

              // Set getTravelForecast text if specified.
              if (organisationResponse?.data?.getTravelForecastText) {
                const {setGetTravelForecastText} = this.context;
                setGetTravelForecastText(
                  organisationResponse?.data?.getTravelForecastText
                );
              }

              if (organisationResponse?.data?.expandPTOptionsModalComponent) {
                const {setExpandPTOptions} = this.context;
                setExpandPTOptions(
                  organisationResponse?.data?.expandPTOptionsModalComponent
                );
              }

              var isPTOptions =
                organisationResponse?.data?.showPTOptionsModalComponent;

              this.safeSetState(
                {
                  ...object,
                  hideEditJourneyButtons: false,
                  isPTOptions: isPTOptions,
                  organisation: organisationResponse.data,
                  isTrafficForecastAvailable:
                    isTrafficForecastAvailable ||
                    organisationResponse.data.trafficForecastEnabled,
                },
                () => {
                  this.getEventsByDestinationGroup(destinationEvents);
                  this.getUrlJourneyPlan(
                    urlValues,
                    destinationEvents,
                    organisationResponse?.data?.showReturnButton
                  );
                  if (response?.data?.journeyResponse) {
                    this.processJourneyResponse(
                      response.data.journeyResponse,
                      isKilometres,
                      null,
                      null
                    );
                  }
                }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.safeSetState(
            {
              ...object,
              organisation: null,
            },
            () => {
              this.getEventsByDestinationGroup(destinationEvents);
              this.getUrlJourneyPlan(urlValues, destinationEvents);
            }
          );
        }
      })
      .catch((error) => {
        console.log(error);
        this.safeSetState({
          error: true,
          showResults: false,
          showLoading: false,
          showInitialLoading: false,
          showLoadingJourneyMessages: false,
          showForm: false,
          mapNotReadyToRender: false,
          errorMapLoad: true,
          errorType: error.response
            ? error.response.data
              ? error.response.data.toString()
              : error.message.toString()
            : error.message.toString(),
          errorMessage: destinationError,
        });
      });
  };

  getUrlJourneyPlan = async (
    values,
    destinationEvents = null,
    showReturn = false
  ) => {
    // Clear URL after loading journeyPlan Params
    if (values?.fields) {
      const currentPath = window.location.pathname;
      const pathSegments = currentPath
        .split("/")
        .filter((segment) => segment !== "");

      // check if personalized travel plan from the url
      const journeyPlanIndex = pathSegments.indexOf("journeyplan");
      if (journeyPlanIndex !== -1) {
        pathSegments.splice(journeyPlanIndex);
      }

      // build again from segments removing query params
      const cleanedPath =
        pathSegments.length > 0 ? `/${pathSegments.join("/")}` : "/";

      window.history.pushState({}, "", cleanedPath);
    }

    // Convert all values to lower case.
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].toLowerCase();
      }
    });

    if (!values.from && !values.fromEvent && !values.to && !values.toEvent) {
      this.setState({
        showLoading: false,
        showInitialLoading: false,
        showLoadingJourneyMessages: false,
        showForm: false,
      });
      return;
    }
    var startLocation = {
      description: values.from || null,
      eventId: values.fromEvent || null,
    };

    var endLocation = {
      description: values.to || null,
      eventId: values.toEvent || null,
    };

    var isTimeUpdated = false;
    var leaveAfterTime = null;
    var arriveByTime = null;

    if (values.leaveafter) {
      leaveAfterTime = new Date(values.leaveafter);
      isTimeUpdated = true;
    } else if (values.arrivebefore) {
      arriveByTime = new Date(values.arrivebefore);
      isTimeUpdated = true;
    }

    var fromDestinationEvent = null;
    var toDestinationEvent = null;

    // If the URL value matches a destination name exactly, use that destinations location.
    if (destinationEvents && destinationEvents.length > 0) {
      fromDestinationEvent = destinationEvents.find(
        (destinationEvent) =>
          destinationEvent.name.toLowerCase() === values?.from?.toLowerCase()
      );

      toDestinationEvent = destinationEvents.find(
        (destinationEvent) =>
          destinationEvent.name.toLowerCase() === values?.to?.toLowerCase()
      );
    }

    // If the toEvent has an endTime, enable return and use that as the return departure time by default.
    if (destinationEvents && destinationEvents.length > 0) {
      if (
        !leaveAfterTime &&
        !arriveByTime &&
        toDestinationEvent?.endTime &&
        showReturn
      ) {
        this.setState({
          selectedReturnDateTime: toDestinationEvent.endTime,
          isReturn: true,
        });
      }

      if (toDestinationEvent) {
        endLocation.description = toDestinationEvent.name;
        endLocation.eventId = toDestinationEvent.eventId;
        endLocation.latitude = toDestinationEvent?.location?.latitude;
        endLocation.longitude = toDestinationEvent?.location?.longitude;
      }

      if (fromDestinationEvent) {
        startLocation.description = fromDestinationEvent.name;
        startLocation.eventId = fromDestinationEvent.eventId;
        startLocation.latitude = fromDestinationEvent?.location?.latitude;
        startLocation.longitude = fromDestinationEvent?.location?.longitude;
      }
    }

    if (values.from === "currentlocation" || values.to === "currentlocation") {
      const userLocation = geolocationService.getCurrentPosition();

      if (userLocation) {
        if (values.from === "currentlocation") {
          startLocation = {
            description: "Current Location",
            latitude: userLocation.latitude,
            longitude: userLocation.longitude,
          };
        }
        if (values.to === "currentlocation") {
          endLocation = {
            description: "Current Location",
            latitude: userLocation.latitude,
            longitude: userLocation.longitude,
          };
        }
      } else {
        if (
          values.from === "currentlocation" ||
          values.to === "currentlocation"
        ) {
          this.setState({
            showLoading: false,
            showInitialLoading: false,
            showLoadingJourneyMessages: false,
            showForm: false,
          });
          return;
        }
      }
    }

    if (values.toEventSourceId) {
      endLocation.sourceId = values.toEventSourceId;
    }

    if (values.fromEventSourceId) {
      startLocation.sourceId = values.fromEventSourceId;
    }

    if (values.fromEventSectionId) {
      startLocation.sectionId = values.fromEventSectionId;
    }

    if (values.toEventSectionId) {
      endLocation.sectionId = values.toEventSectionId;
    }

    this.setState({
      startLocation: startLocation,
      endLocation: endLocation,
    });

    if (
      _.every(startLocation, (value) => value == null) ||
      _.every(endLocation, (value) => value == null)
    ) {
      this.setState({
        showLoading: false,
        showInitialLoading: false,
        showLoadingJourneyMessages: false,
        showForm: false,
      });
      return;
    }

    var journeyPlan = {
      startLocation,
      endLocation,
      departureTime: leaveAfterTime,
      arrivalTime: arriveByTime,
    };

    console.log(journeyPlan);
    var filters = {
      ...defaultFilters,
      startLocation: journeyPlan.startLocation,
      endLocation: journeyPlan.endLocation,
    };
    this.postJourneyOptions(journeyPlan, filters, isTimeUpdated, null, true);

    if (values.isReturn === "true") {
      this.setIsReturn(true);
    }
  };

  maxPaddingCalculator = (padding, width, height) => {
    const maxPadding = Math.min(width, height) / 3;
    return maxPadding < padding ? maxPadding : padding;
  };

  createViewPort = (
    boundingBox,
    overrideZoomLevel,
    maxZoomLevel,
    mobilePadding,
    desktopPadding,
    isJourneyMap
  ) => {
    maxZoomLevel = maxZoomLevel ? maxZoomLevel : 19;
    const calculatedJourneyMapHeight =
      this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD
        ? this.refs.Map.clientHeight - MOBILE_MAP_HEIGHT_GAP
        : this.refs.Map.clientHeight;
    const calculatedJourneyMapWidth =
      this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD
        ? this.refs.Map.clientWidth
        : this.refs.Map.clientWidth - DESKTOP_JOURNEY_MAP_WIDTH_GAP;
    const calculatedMapHeight =
      this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD
        ? this.refs.Map.clientHeight - MOBILE_MAP_HEIGHT_GAP
        : this.refs.Map.clientHeight;

    // console.log( "calculatedMapHeight ", calculatedMapHeight );
    // console.log( " this.refs.Map.clientHeight", this.refs.Map.clientHeight );
    // console.log( "isJourneyMap", isJourneyMap )

    var viewport;

    if (
      boundingBox.maxLongitude === boundingBox.minLongitude ||
      boundingBox.maxLatitude === boundingBox.minLatitude
    ) {
      viewport = {
        width: this.refs.Map.clientWidth,
        height: this.refs.Map.clientHeight,
        latitude:
          (boundingBox.minLatitude * 1 + boundingBox.maxLatitude * 1) / 2,
        longitude:
          (boundingBox.minLongitude * 1 + boundingBox.maxLongitude * 1) / 2,
        zoom:
          boundingBox.zoomLevel && boundingBox.zoomLevel < maxZoomLevel
            ? boundingBox.zoomLevel
            : maxZoomLevel,
      };
    } else {
      // console.log( "isJourneyMap", isJourneyMap );
      // console.log( "calculatedJourneyMapWidth", calculatedJourneyMapWidth );
      // console.log( " this.refs.Map.clientWidth", this.refs.Map.clientWidth );
      // console.log( "calculatedJourneyMapHeight", calculatedJourneyMapHeight );
      // console.log( "calculatedMapHeight", calculatedMapHeight );
      // console.log( this.maxPaddingCalculator(
      //   this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD ? mobilePadding : desktopPadding,
      //   isJourneyMap ? calculatedJourneyMapWidth : this.refs.Map.clientWidth,
      //   calculatedMapHeight
      // ) );

      viewport = new WebMercatorViewport({
        width: isJourneyMap
          ? calculatedJourneyMapWidth
          : this.refs.Map.clientWidth,
        height: isJourneyMap ? calculatedJourneyMapHeight : calculatedMapHeight,
      }).fitBounds(
        [
          [boundingBox.maxLongitude, boundingBox.maxLatitude],
          [boundingBox.minLongitude, boundingBox.minLatitude],
        ],
        this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD
          ? {
            padding: this.maxPaddingCalculator(
              mobilePadding,
              this.refs.Map.clientWidth, // FULL WIDTH IN ANY CASE
              isJourneyMap ? calculatedJourneyMapHeight : calculatedMapHeight
            ),
            // maxZoom does not seem like essential removed with TA-2525
            // maxZoom: maxZoomLevel
          }
          : {
            padding: this.maxPaddingCalculator(
              desktopPadding,
              isJourneyMap
                ? calculatedJourneyMapWidth
                : this.refs.Map.clientWidth,
              calculatedMapHeight
            ),
            // maxZoom does not seem like essential removed with TA-2525
            // maxZoom: maxZoomLevel
          }
      );
    }

    if (overrideZoomLevel != null) {
      viewport = {
        latitude: viewport.latitude,
        longitude: viewport.longitude,
        zoom: overrideZoomLevel,
      };
    }

    return viewport;
  };

  getEventsByDestinationGroup = (newDestinationEvents) => {
    this.setState({error: false});

    var prioritizedDestinationEvent = this.state.activeDestinationEvent;
    var isPrioritizedPopUp = false;
    var destinationEvents = [...this.state.destinationEvents];

    newDestinationEvents.forEach(function (destinationEvent) {
      if (destinationEvent.prioritizedPopUp === true) {
        isPrioritizedPopUp = true;
        prioritizedDestinationEvent = destinationEvent;
      }
      destinationEvent.isMainDestinationGroup = true;
      destinationEvents.push(destinationEvent);
    });

    this.setState({
      singleNonMDDestinationEvent: prioritizedDestinationEvent,
      selectedReturnDateTime: prioritizedDestinationEvent?.endTime
        ? moment(prioritizedDestinationEvent?.endTime)
        : this.state.selectedReturnDateTime,
      destinationEvents: destinationEvents,
      departureTime: null,
      mapNotReadyToRender: false,
      isPrioritizedPopUp: isPrioritizedPopUp,
      activeDestinationEvent: prioritizedDestinationEvent,
      initOperations: true,
    });

    if (this.state.markerOptions !== undefined) {
      for (var index = 0; index < this.state.markerOptions.length; index++) {
        if (
          this.state.markerOptions[index].initialDisplay !== undefined &&
          this.state.markerOptions[index].initialDisplay === true
        ) {
          this.markerOptionsAction(index);
        }
      }
    }

    let activeDestinationEvent = null;

    if (this.state.defaultFrom && this.state.defaultFrom !== "None") {
      activeDestinationEvent = destinationEvents.find(
        (d) =>
          d.destinationId.toLowerCase() === this.state.defaultFrom.toLowerCase()
      );
    } else if (this.state.defaultTo && this.state.defaultTo !== "None") {
      activeDestinationEvent = destinationEvents.find(
        (d) =>
          d.destinationId.toLowerCase() === this.state.defaultTo.toLowerCase()
      );
    } else if (
      this.state.defaultFrom !== "None" &&
      this.state.defaultTo !== "None"
    ) {
      activeDestinationEvent = destinationEvents[0];
    }

    if (this.state.isPrioritizedPopUp) {
      activeDestinationEvent = destinationEvents.find(
        (d) =>
          d.destinationId.toLowerCase() ===
          this.state.activeDestinationEvent.destinationId.toLowerCase()
      );
      if (this.state.isMultiDestination)
        this.setActiveDestinationEventOnMap(activeDestinationEvent);
    }

    if (!this.state.isMultiDestination) {
      this.setActiveDestinationEventOnMap(activeDestinationEvent);
    }
  };

  getFilterUserTravelPlans = (past) => {
    const apimUser = userLocalDataService.getAPIMUser();
    const userIdentityEmail = this.state.thirdPartyAuthenticated
      ? this.state.thirdPartyLogin.email
      : apimUser.identityEmail;

    this.getUserTravelPlans(userIdentityEmail, past);
  };

  getUserTravelPlans = (userIdentityEmail, past) => {
    const currentLocation = geolocationService.getCurrentPosition();
    const url =
      "travelForecastsByUser/" +
      userIdentityEmail +
      "/" +
      past +
      (currentLocation
        ? "/" + currentLocation.latitude + "/" + currentLocation.longitude
        : "");
    restServiceGet(this.props.apiToken, url)
      .then((response) => {
        if (response.data.length !== 0) {
          if (past) {
            this.setState({
              pastTravelPlans: response.data,
            });
          } else {
            this.setState({
              previousTravelPlans: response.data,
            });
          }
        }
        this.setState({
          showLoading: false,
          showInitialLoading: false,
          showLoadingJourneyMessages: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          error: true,
          showLoading: false,
          errorType: error.response
            ? error.response.data
              ? error.response.data.toString()
              : error.message.toString()
            : error.message.toString(),
          errorMessage: travelPlanError,
        });
        if (error.response && error.response.status === 401)
          this.props.auth.login();
      });
  };

  _fetchAssistanceRequestData = async (travelPlanId) => {
    var url = "travelForecast/" + travelPlanId + "/assistance";

    restServiceGet(this.props.apiToken, url)
      .then((response) => {
        const assistanceRequestData = response.data;

        var assistedLatitude = null;
        var assistedLongitude = null;
        if (assistanceRequestData.userPositions) {
          var assistedPosition = assistanceRequestData.userPositions
            .slice(-1)
            .pop();
          if (
            assistedPosition &&
            assistedPosition.geoPosition &&
            assistedPosition.geoPosition.coordinates[1] &&
            assistedPosition.geoPosition.coordinates[0]
          ) {
            assistedLatitude = assistedPosition.geoPosition.coordinates[1];
            assistedLongitude = assistedPosition.geoPosition.coordinates[0];
          }
          assistanceRequestData.assistedLatitude = assistedLatitude;
          assistanceRequestData.assistedLongitude = assistedLongitude;
        }

        if (assistedLatitude && assistedLongitude) {
          this.setState(
            {
              assistanceRequestData,
            },
            () => {
              //If location information could not be fetched dont use current location logic
              if (assistedLatitude !== 0) {
                this.getCurrentPosition(false);
              }
            }
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching assistance request data:", error);
      });
  };

  getJourneyPlanResponseService = async (
    url,
    travelPlanId,
    checkForUpdates,
    assist
  ) => {
    restServiceGet(this.props.apiToken, url)
      .then((response) => {
        let journeyResponse = response.data.journeyResponse;
        let returnJourneyResponse = response.data.returnJourneyResponse;

        this.postUnsecureUserPosition(journeyResponse.journeyPlanId, {
          ...this.state.unsecureUserPosition,
          RequestSent: moment.parseZone().format(),
        });

        // Enable the alerts button.
        this.setAlertsButton(false);

        // Set miles/kilometres.
        if (response?.data?.destinationGroup?.isKilometres === true) {
          const {setIsKilometres} = this.context;
          setIsKilometres(true);
        }

        // Hide elements on page if specified.
        if (journeyResponse?.organisation?.hideClientElements?.length > 0) {
          const {setHideClientElements} = this.context;
          setHideClientElements(
            journeyResponse.organisation.hideClientElements
          );
        }

        // Set getTravelForecast text if specified.
        if (journeyResponse?.organisation?.getTravelForecastText) {
          const {setGetTravelForecastText} = this.context;
          setGetTravelForecastText(
            journeyResponse?.organisation?.getTravelForecastText
          );
        }

        if (journeyResponse?.organisation?.carbonRemoval) {
          const {setCarbonRemovalValues} = this.context;
          setCarbonRemovalValues(journeyResponse.organisation.carbonRemoval);
        }

        // Use the selected journey option's bounding box instead of overall response bounding box
        const selectedJourneyOptionForViewport =
          journeyResponse.journeyOptions.find(
            (el) => el.id === journeyResponse.journeyOptionId
          ) || journeyResponse.journeyOptions[0];

        const initialBoundingBox =
          selectedJourneyOptionForViewport?.boundingBox ||
          journeyResponse.boundingBox;

        // Calculate viewport from bounding box using existing createViewPort logic
        const newViewport = this.createViewPort(
          initialBoundingBox,
          null, // overrideZoomLevel
          19, // maxZoomLevel
          50, // mobilePadding
          100, // desktopPadding
          true // isJourneyMap
        );

        this.setState(
          {
            customMapURL: response?.data?.destinationGroup.customMapURL,
            mapNotReadyToRender: false,
            boundingBox: initialBoundingBox,
            viewport: newViewport, // Update viewport to update initialViewState
            updateMap: this.state.updateMap + 1, // Force map re-render with new viewport
            hideEditJourneyButtons: false,
          },
          () => {
            // set assistance request bounding box after initial bounding box operations
            if (assist) {
              this._fetchAssistanceRequestData(travelPlanId);
            }
          }
        );

        let destinationEvents = response?.data?.destinationEvents;
        const request = journeyResponse.request;
        let tempDestinationEvents = [];

        const tempResp = journeyResponse;
        const journeyPlanId = journeyResponse.journeyPlanId;
        const travelPlan = travelPlanId;
        const destinationGroup = response?.data?.destinationGroup;
        const journeyOptions = journeyResponse.journeyOptions;
        const journeyOptionId = journeyResponse.journeyOptionId;
        const isEvDestinationGroup =
          destinationGroup &&
            destinationGroup.journeyConfig &&
            destinationGroup.journeyConfig.journeyOrder
            ? destinationGroup.journeyConfig.journeyOrder.filter(
              (x) => x === 65
            ).length > 0
            : false;

        const selectedJourneyOption = journeyOptions.find(
          (el) => el.id === journeyOptionId
        );

        var returnTempResp;
        var returnJourneyPlanID;
        var returnDepartureTime;
        var returnArrivalTime;
        var returnJourneyOptionId;
        var selectedReturnJourneyOption;

        if (returnJourneyResponse) {
          const {setShowReturnButton} = this.context;
          setShowReturnButton(true);

          returnTempResp = returnJourneyResponse;
          returnDepartureTime = returnJourneyResponse.request.departureTime;
          returnArrivalTime = returnJourneyResponse.request.arrivalTime;
          returnJourneyPlanID = returnJourneyResponse.journeyPlanId;
          returnJourneyOptionId = returnJourneyResponse.journeyOptionId;
          selectedReturnJourneyOption =
            returnJourneyResponse.journeyOptions.find(
              (el) => el.id === returnJourneyOptionId
            );
          returnTempResp.journeyOptions.forEach((journey) => {
            if (
              !selectedReturnJourneyOption ||
              journey.order === selectedReturnJourneyOption.order
            ) {
              journey.show = true;
              journey.active = true;
            } else {
              journey.show = false;
              journey.active = false;
            }
          });

          if (selectedReturnJourneyOption === null) {
            returnTempResp.journeyOptions[0].active = true;
          }
        }

        var startEventId = null;
        var endEventId = null;
        var startLocation = null;
        var endLocation = null;

        if (journeyResponse.request.startLocation.eventId) {
          startEventId = journeyResponse.request.startLocation.eventId;
        }

        if (journeyResponse.request.endLocation.eventId) {
          endEventId = journeyResponse.request.endLocation.eventId;
        }

        if (destinationGroup.accessibilityToolEnabled) {
          this.handleAccessibility();
        }

        var destinationGroupShortCode = destinationGroup.shortCode;

        var data = {
          organisation: journeyResponse.organisation,
          destinationGroup: destinationGroup,
          destinationGroupId: destinationGroup.id,
          organisationId: destinationGroup.organisationId,
          markerOptions: destinationGroup.markerOptions,
          clusteringEnabled: destinationGroup.clusteringEnabled ? true : false,
          isTrafficForecastAvailable:
            journeyResponse.organisation.trafficForecastEnabled === true
              ? true
              : false,
          destinationGroupAssistanceSettings:
            destinationGroup.assistanceSettings,
          isCheckForUpdate: !checkForUpdates,
        };

        var filters = journeyResponse.request.additionalFilters;

        var destinationEventsInState = [...this.state.destinationEvents];
        var originLocation = startEventId
          ? destinationEvents.find(
            (de) => de.eventId.toLowerCase() === startEventId.toLowerCase()
          )
          : null;

        var destinationLocation = endEventId
          ? destinationEvents.find(
            (el) => el.eventId.toLowerCase() === endEventId.toLowerCase()
          )
          : null;

        if (!originLocation) {
          originLocation = {
            location: journeyResponse.request.startLocation,
            name: journeyResponse.request.description,
          };
        }

        if (!destinationLocation) {
          destinationLocation = {
            location: journeyResponse.request.endLocation,
            name: journeyResponse.request.description,
          };
        }

        destinationEvents.forEach(function (destinationEvent) {
          destinationEvent.isMainDestinationGroup = true;
          destinationEventsInState.push(destinationEvent);
        });

        this.setState({destinationEvents: destinationEventsInState});
        if (this.state.isMultiDestination) {
          tempDestinationEvents = destinationEvents;
        } else {
          destinationEvents.forEach(function (destinationEvent) {
            tempDestinationEvents.push(destinationEvent);
          });
        }

        var dEvents = tempDestinationEvents;

        dEvents.push(destinationEvents);
        this.setState(() => {
          return {
            ...data,
            destinationEvents: destinationEvents,
            originLocation: originLocation,
            destinationLocation: destinationLocation,
            startLocation: startLocation,
            endLocation: endLocation,
            journeyPlanId: journeyPlanId,
            isReturn: !!returnJourneyResponse,
            returnJourneyPlanId: returnJourneyPlanID,
            selectedJourneyOption: selectedJourneyOption,
            selectedReturnJourneyOption: selectedReturnJourneyOption,
            travelPlanID: travelPlan,
            activeJourney: selectedJourneyOption.order,
            activeReturnJourney: selectedReturnJourneyOption
              ? selectedReturnJourneyOption.order
              : 0,
            activeJourneyLegs: selectedJourneyOption.legs,
            activeReturnJourneyLegs: selectedReturnJourneyOption
              ? selectedReturnJourneyOption.legs
              : [],
            itineraryEnabled:
              destinationGroup !== undefined
                ? destinationGroup.itineraryenabled
                : false,
            journeys: tempResp,
            returnJourneys: returnTempResp,
            searched: true,
            showResults: true,
            isEvDestinationGroup: isEvDestinationGroup, // ??
            destinationGroupShortCode: destinationGroupShortCode,
            customMapURL:
              destinationGroup.customMapURL !== undefined
                ? destinationGroup.customMapURL
                : MAPTILER_PATH_WITH_TOKEN,
            showLoading: false,
            showInitialLoading: false,
            showLoadingJourneyMessages: false,
            showTravelPlan: true,
            filters: {
              filterAdults: filters.filterAdults,
              filterChildren: filters.filterChildren,
              filterWheelchair: filters.filterWheelchair,
              filterLuggage: filters.filterLuggage,
              filterGuideDog: filters.filterGuideDog,
              filterBicycle: filters.filterBicycle,
              filterRemainingRange: filters.filterRemainingRange,
              filterMaximumRange: filters.filterMaximumRange,
              filterChargingTime: filters.filterChargingTime,
              filterChademo: filters.filterChademo,
              filterComboCCS: filters.filterComboCCS,
              filterRapidAC43: filters.filterRapidAC43,
              departureTime: tempResp.request.departureTime,
              arrivalTime: tempResp.request.arrivalTime,
              returnDepartureTime: returnDepartureTime,
              returnArrivalTime: returnArrivalTime,
              startLocation: request.startLocation,
              endLocation: request.endLocation,
              viaLocations: request.viaLocations,
            },
            destinationGroupName: destinationGroup.name,
          };
        });

        journeyOptions.forEach((journey) => {
          if (
            selectedJourneyOption === null ||
            journey.order === selectedJourneyOption.order
          ) {
            journey.show = true;
            journey.active = true;
          } else {
            journey.show = false;
            journey.active = false;
          }
        });

        if (selectedJourneyOption === null) {
          journeyOptions[0].active = true;
        }

        this.setState({
          journeyOptions: journeyOptions,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          showResults: false,
          showLoading: false,
          showInitialLoading: false,
          showLoadingJourneyMessages: false,
          showForm: false,
        });
      });
  };

  getJourneyPlanResponse = (journeyplanid, journeyoptionid, shortcode) => {
    this.setState({
      showLoading: false,
      showInitialLoading: true,
      showResults: false,
      error: false,
    });
    var url = "journeyplan/" + journeyplanid + "/" + journeyoptionid + "/";

    this.getJourneyPlanResponseService(url, null, false, false);
  };

  getTravelPlan = (travelPlanId, checkForUpdates, assist) => {
    //Check if permissions have already been granted, and if they have, display the users current position anyway
    if (!assist) {
      //Check if permissions have already been granted, and if they have, display the users current position anyway
      const displayLocationIfPermissionGiven = async () => {
        try {
          if (navigator.permissions && navigator.permissions.query) {
            const permissionStatus = await navigator.permissions.query({
              name: "geolocation",
            });
            if (permissionStatus.state === "granted") {
              try {
                this.getCurrentPosition(false);
              } catch (e) {
                console.warn("Error getting current position:", e);
              }
            }
          }
        } catch (error) {
          console.warn("Error checking geolocation permissions:", error);
        }
      };
      displayLocationIfPermissionGiven();
    }

    this.setState({
      showLoading: false,
      showInitialLoading: true,
      showResults: false,
      error: false,
    });

    const currentLocation = geolocationService.getCurrentPosition();

    var url =
      "travelForecast/" +
      travelPlanId +
      "/" +
      (checkForUpdates ? true : false) +
      (currentLocation
        ? "/" + currentLocation.latitude + "/" + currentLocation.longitude
        : "");

    this.getJourneyPlanResponseService(
      url,
      travelPlanId,
      checkForUpdates,
      assist
    );
  };

  createUserProfile = () => {
    const apimUser = userLocalDataService.getAPIMUser();
    let user = this.state.thirdPartyAuthenticated
      ? this.state.thirdPartyLogin.email
      : apimUser.identityEmail ?? "";
    let data = {
      additionalFilters: [
        {
          ...defaultFilters,
        },
      ],
      AssistanceSettings: null,
      isDayBeforeChecked: false,
      isDisruptionChecked: false,
      isWeekBeforeChecked: false,
    };

    restServicePost(this.props.apiToken, "profile/" + user, data)
      .then((response) => {
        this.setState({profileId: response.data});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  updateUserPosition = () => {
    navigator.geolocation.getCurrentPosition(
      this.sendCurrentPosition.bind(this),
      () => { }
    );
  };

  sendCurrentPosition = (location) => {
    if (
      location &&
      location.coords &&
      location.coords.latitude &&
      location.coords.longitude
    ) {
      const apimUser = userLocalDataService.getAPIMUser();

      let data = {
        Latitude: location.coords.latitude,
        Longitude: location.coords.longitude,
        Elevation: location.coords.altitude,
        Accuracy: location.coords.altitudeAccuracy,
      };

      if (apimUser?.identityEmail) {
        restServicePost(
          this.props.apiToken,
          "updateUserLastPosition/" + apimUser.identityEmail,
          data
        )
          .then((response) => { })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  saveEditProfileInfo = (param) => {
    if (this.state.profileId === null) {
      this.createUserProfile();
    }

    restServiceGet(this.props.apiToken, "profile/" + this.state.profileId)
      .then((response) => {
        const updatedObj = [
          {
            ...response.data.additionalFilters[0],
            filterAdults: param.filterAdults,
            filterChildren: param.filterChildren,
            filterWheelchair: param.filterWheelchair,
            filterGuideDog: param.filterGuideDog,
            filterLuggage: param.filterLuggage,
            filterBicycle: param.filterBicycle,
            filterRemainingRange: param.filterRemainingRange,
            filterMaximumRange: param.filterMaximumRange,
            filterChargingTime: param.filterChargingTime,
            filterChademo: param.filterChademo,
            filterComboCCS: param.filterComboCCS,
            filterRapidAC43: param.filterRapidAC43,
          },
        ];
        const data = {
          ...response.data,
          additionalFilters: updatedObj,
        };

        return restServicePut(
          this.props.apiToken,
          "profile/" + this.state.profileId,
          data
        ).catch((error) => {
          console.log(error);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getProfileFilters = () => {
    const apimUser = authLocalDataService.getAPIMUser();
    if (apimUser) {
      let userEmail = this.state.thirdPartyAuthenticated
        ? this.state.thirdPartyLogin.email
        : apimUser.identityEmail ?? "";

      restServiceGet(this.props.apiToken, "profileByUserIdentity/" + userEmail)
        .then((response) => {
          this.setState({
            profileId: response.data.id,
            profilefilter: {
              filterAdults: response.data.additionalFilters[0].filterAdults,
              filterChildren: response.data.additionalFilters[0].filterChildren,
              filterWheelchair:
                response.data.additionalFilters[0].filterWheelchair,
              filterGuideDog: response.data.additionalFilters[0].filterGuideDog,
              filterLuggage: response.data.additionalFilters[0].filterLuggage,
              filterBicycle: response.data.additionalFilters[0].filterBicycle,
              filterRemainingRange:
                response.data.additionalFilters[0].filterRemainingRange,
              filterMaximumRange:
                response.data.additionalFilters[0].filterMaximumRange,
              filterChargingTime:
                response.data.additionalFilters[0].filterChargingTime,
              filterChademo: response.data.additionalFilters[0].filterChademo,
              filterComboCCS: response.data.additionalFilters[0].filterComboCCS,
              filterRapidAC43:
                response.data.additionalFilters[0].filterRapidAC43,
            },
            assistanceSettings: response.data.assistanceSettings
              ? {
                isCurrentLocationShared:
                  response.data.assistanceSettings.isCurrentLocationShared,
                isTravelPlanShared:
                  response.data.assistanceSettings.isTravelPlanShared,
                contacts: [
                  {
                    email: response.data.assistanceSettings.contacts[0].email,
                    name: response.data.assistanceSettings.contacts[0].name,
                    phone: response.data.assistanceSettings.contacts[0].phone,
                    status:
                      response.data.assistanceSettings.contacts[0].status,
                  },
                ],
              }
              : {
                isCurrentLocationShared: false,
                isTravelPlanShared: false,
                contacts: [
                  {
                    email: null,
                    name: null,
                    phone: null,
                  },
                ],
              },
          });
          if (this.state.assistanceSettings !== null) {
            if (this.state.assistanceSettings.contacts.length !== 0) {
              if (
                this.state.assistanceSettings.contacts[0].status === "Pending"
              ) {
                this.setState({showPendingAssistance: true});
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  postJourneyOptions = async (
    journeyPlan,
    filters,
    timeUpdated,
    publicTransportationOptions,
    shouldUpdateReturnJourneys
  ) => {
    if (!journeyPlan.startLocation || !journeyPlan.endLocation) return;

    var originLocation;
    var destinationLocation;
    var excludeModes = [];

    this.state.destinationEvents.forEach(function (destinationEvent) {
      if (journeyPlan.startLocation?.eventId === destinationEvent.eventId) {
        originLocation = destinationEvent;
      }
      if (journeyPlan.endLocation?.eventId === destinationEvent.eventId) {
        destinationLocation = destinationEvent;
      }
    });

    if (!originLocation) {
      originLocation = {
        location: journeyPlan.startLocation,
        name: journeyPlan.startLocation.description,
      };
    }

    if (!destinationLocation) {
      destinationLocation = {
        location: journeyPlan.endLocation,
        name: journeyPlan.endLocation.description,
      };
    }

    if (this.state.isPTOptions) {
      if (!publicTransportationOptions.filterBus) {
        excludeModes.push("Bus");
        excludeModes.push("Coach");
      }
      if (!publicTransportationOptions.filterTrain) {
        excludeModes.push("Rail");
      }
      if (!publicTransportationOptions.filterTram) {
        excludeModes.push("Tram");
      }
    }

    this.setState({
      showLoadingJourneyMessages: true,
      showResults: false,
      showForm: false,
      error: false,
      showAssistantInformation: false,
      activeLeg: null,
      viewportMarker: null,
    });

    if (shouldUpdateReturnJourneys) {
      this.clearReturnJourneys();
    }

    const {isKilometres} = this.context;

    const data = {
      journeyPlanId: this.state.journeyPlanId,
      isReturnJourney: journeyPlan.isReturnJourney,
      travelPlanID: this.state.travelPlanID,
      destinationGroupShortCode: this.state.destinationGroupShortCode,
      destinationGroupId: this.state.destinationGroupId
        ? this.state.destinationGroupId
        : this.state.destinationGroup.Id,
      organisationId: this.state.organisationId
        ? this.state.organisationId
        : this.state.destinationGroup.organisationId,
      endLocation: journeyPlan.endLocation,
      departureTime:
        journeyPlan.departureTime === null && journeyPlan.arrivalTime == null
          ? moment.parseZone().format()
          : journeyPlan.departureTime,
      arrivalTime: journeyPlan.arrivalTime,
      startLocation: journeyPlan.startLocation,
      journeyPlanner: "Auto",
      includeWaypoints: false,
      includeTrackpoints: true,
      excludeModes: excludeModes,
      includeIntermediateStops: true,
      additionalFilters: {
        ...filters,
        isKilometres: isKilometres,
      },
      timeUpdated: timeUpdated,
      chargeWayPoint: this.state.chargeWayPoint,
      viaLocations: journeyPlan.viaLocations,
      latestUserPosition:
        this.state.unsecureUserPosition &&
          this.state.unsecureUserPosition.GeoPosition
          ? {
            GeoPosition: this.state.unsecureUserPosition.GeoPosition,
            RequestSent: moment.parseZone().format(),
          }
          : null,
      includeAdvertisements: true,
      advertisementMode: "journey",
      customerId: safeLocalStorageService.getItem("customerId") || null,
    };
    console.log("journeyOptions:request", data);

    try {
      const response = await restServicePost(
        this.props.apiToken,
        "journeyOptions",
        data
      );
      console.log("journeyOptions:response", response);

      if (response.status !== 200) {
        throw new Error(response?.data?.statusMessage || journeyPlanError);
      }

      this.processJourneyResponse(
        response.data,
        isKilometres,
        originLocation,
        destinationLocation
      );
    } catch (error) {
      console.log(error);

      this.setState({
        error: true,
        errorType: journeyPlanError,
        errorMessage: error?.response?.data || journeyPlanError,
        showResults: false,
        showLoading: false,
        showInitialLoading: false,
        showLoadingJourneyMessages: false,
        showForm: false,
      });
    }
  };

  postReturnJourneyOptions = async (
    journeyPlan,
    filters,
    timeUpdated,
    publicTransportationOptions
  ) => {
    if (journeyPlan.startLocation === "" || journeyPlan.endLocation === "")
      return;

    var excludeModes = [];

    if (this.state.isPTOptions) {
      if (!publicTransportationOptions.filterBus) {
        excludeModes.push("Bus");
        excludeModes.push("Coach");
      }
      if (!publicTransportationOptions.filterTrain) {
        excludeModes.push("Rail");
      }
      if (!publicTransportationOptions.filterTram) {
        excludeModes.push("Tram");
      }
    }

    const {isKilometres} = this.context;

    const returnData = {
      journeyPlanId: this.state.journeyPlanId,
      travelPlanID: this.state.travelPlanID,
      destinationGroupId: this.state.destinationGroupId
        ? this.state.destinationGroupId
        : this.state.destinationGroup.Id,
      organisationId: this.state.organisationId
        ? this.state.organisationId
        : this.state.destinationGroup.organisationId,
      departureTime: journeyPlan.returnDepartureTime,
      arrivalTime: journeyPlan.returnArrivalTime,
      journeyPlanner: "Auto",
      includeWaypoints: false,
      includeTrackpoints: true,
      excludeModes: excludeModes,
      includeIntermediateStops: true,
      additionalFilters: {
        ...filters,
        isKilometres: isKilometres,
      },
      timeUpdated: timeUpdated,
      chargeWayPoint: this.state.chargeWayPoint,
      viaLocations: journeyPlan.viaLocations,
      isReturnJourney: true,
      startLocation: journeyPlan.endLocation,
      endLocation: journeyPlan.startLocation,
      includeAdvertisements: true,
      advertisementMode: "journey",
    };

    try {
      const promises = [];

      console.log("returnJourneyOptions:request", returnData);
      promises.push(
        restServicePost(this.props.apiToken, "journeyOptions", returnData)
      );

      const responses = await Promise.all(promises);

      let returnResponse;

      returnResponse = responses[0];
      console.log("returnJourneyOptions:response", returnResponse);

      if (returnResponse.status === 200) {
        returnResponse.data.journeyOptions.forEach((journey) => {
          journey.show = true;
          journey.active = false;
        });

        this.setState({
          returnJourneyPlanId: returnResponse?.data
            ? returnResponse.data.journeyPlanId
            : null,
          returnJourneys: returnResponse?.data ? returnResponse.data : [],
          activeReturnJourneyLegs: returnResponse?.data
            ? returnResponse.data.journeyOptions[0].legs
            : [],
          returnDepartureTime: returnResponse?.data
            ? returnResponse.data.departureTime
            : null,
          returnArrivalTime: returnResponse?.data
            ? returnResponse.data.arrivalTime
            : null,
          filters: {
            ...this.state.filters,
            viaLocations: returnResponse.data.request.viaLocations,
            isKilometres: isKilometres,
            returnDepartureTime: returnResponse?.data
              ? returnResponse.data.departureTime
              : null,
            returnArrivalTime: returnResponse?.data
              ? returnResponse.data.arrivalTime
              : null,
          },
        });

        if (this.state.showTravelPlan) {
          this.setState({
            filters: {
              ...this.state.filters,
              returnDepartureTime: returnResponse?.data
                ? returnResponse.data.departureTime
                : null,
              returnArrivalTime: returnResponse?.data
                ? returnResponse.data.arrivalTime
                : null,
            },
          });
        } else if (returnResponse.status) {
          var errorType = returnResponse?.data?.statusMessage;
          this.setState({
            error: true,
            errorType: journeyPlanError,
            errorMessage: errorType ?? journeyPlanError,
            showResults: false,
            showLoading: false,
            showInitialLoading: false,
            showLoadingJourneyMessages: false,
            showForm: false,
          });
        }
      } else {
        const errorType = returnResponse?.data?.statusMessage;
        this.setState({
          error: true,
          errorType: journeyPlanError,
          errorMessage: errorType ?? journeyPlanError,
          showResults: false,
          showLoading: false,
          showInitialLoading: false,
          showLoadingJourneyMessages: false,
          showForm: false,
        });
      }
    } catch (error) {
      console.log(error);

      const errorType = error?.response?.data?.statusMessage;

      this.setState({
        error: true,
        errorType: journeyPlanError,
        errorMessage: errorType ?? journeyPlanError,
        showResults: false,
        showLoading: false,
        showInitialLoading: false,
        showLoadingJourneyMessages: false,
        showForm: false,
      });
    }
  };

  postUser = (
    user,
    travelForecast,
    journeyOptionId,
    destinationName,
    boostCompliant
  ) => {
    this.setState({
      showLoading: true,
    });
    let userIdentityEndPoint = "userIdentityUnsecure";

    const apimUser = userLocalDataService.getAPIMUser();

    user.identityEmail =
      apimUser?.identityEmail ?? user.identityEmail ?? user.emailAddress;
    user.channel = 1;

    const hasReturnJourneys =
      this.state.returnJourneys?.journeyOptions?.length > 0;

    restServicePost(this.props.apiToken, userIdentityEndPoint, user)
      .then((response) => {
        console.log(userIdentityEndPoint, response.data);
        this.postTravelForecast(
          {
            departureTime: this.state.showTravelPlan
              ? this.state.filters.departureTime
              : this.state.departureTime,
            arrivalTime: this.state.showTravelPlan
              ? this.state.filters.arrivalTime
              : this.state.arrivalTime,
            journeyOptionId: journeyOptionId
              ? journeyOptionId
              : this.state.journeys.journeyOptions[this.state.activeJourney].id,
            returnJourneyOptionId: hasReturnJourneys
              ? this.state.returnJourneys.journeyOptions[
                this.state.activeReturnJourney
              ].id
              : null,
            journeyPlanId: this.state.journeyPlanId,
            returnJourneyPlanId: this.state?.returnJourneyPlanId
              ? this.state.returnJourneyPlanId
              : null,
            language: this.props.contextWrapper.lang,
            userIdentityId: response.data.id,
            userNotificationMail: user.emailAddress,
            userNotificationMobile: user.mobilePhoneNumber,
            status:
              travelForecast.status.length === 0
                ? travelForecast.status.push("NeverNotify")
                : travelForecast.status,
            notifications: true,
            useWhatsApp: travelForecast.useWhatsApp,
            mode: this.state.journeys.journeyOptions[this.state.activeJourney]
              .mode,

            destinationGroupName: !destinationName
              ? this.state.destinationGroupShortCode
              : destinationName,
            destinationGroupId: this.state.destinationGroupId
              ? this.state.destinationGroupId
              : this.state.destinationGroup.Id,
            organisationId: this.state.organisationId
              ? this.state.organisationId
              : this.state.destinationGroup.organisationId,
            // null check required since it can be anywhere tto anywhere jou,rneys
            eventId:
              this.state.activeDestinationEvent != null
                ? this.state.activeDestinationEvent.eventId
                : null,
            eventName:
              this.state.activeDestinationEvent != null
                ? this.state.activeDestinationEvent.name
                : null,
            notificationAutomaticApproval:
              this.state.organisation != null
                ? this.state.organisation.notificationAutomaticApproval
                : null,
            boostCompliant,
          },
          {
            itineraryId: this.state.journeyPlanId,
            journeyOptionId:
              this.state.journeys.journeyOptions[this.state.activeJourney].id,
            legs:
              this.state.legs.length !== 0
                ? this.state.legs
                : this.state.activeJourneyLegs,
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  postTravelForecast = (travelForecast, itinerary) => {
    let travelForecastEndpoint = "travelForecastUnsecure";

    restServicePost(this.props.apiToken, travelForecastEndpoint, travelForecast)
      .then((response) => {
        if (this.state.isItineraryActive && this.state.legs.length !== 0) {
          let itineraryDwellTimeEndPoint = "itineraryDwellTime";
          this.updateUserPosition();
          restServicePost(
            this.props.apiToken,
            itineraryDwellTimeEndPoint,
            itinerary
          )
            .then((response) => {
              this.setState({
                showForm: false,
                showResults: false,
                showLoading: false,
                showInitialLoading: false,
                showLoadingJourneyMessages: false,
                showConfirmation: true,
              });
            })
            .catch((error) => {
              console.log(error);
              if (error.response.status === 401) this.props.auth.login();
            });
        } else {
          this.setState({
            showForm: false,
            showResults: false,
            showLoading: false,
            showInitialLoading: false,
            showLoadingJourneyMessages: false,
            showConfirmation: true,
          });
        }
      })

      .catch((error) => {
        console.log(error);
        if (error.response.status === 401) this.props.auth.login();
      });
  };

  postThirdPartyTravelForecast = (
    journeyPlanId,
    journeyOption,
    userIdentityId,
    customData,
    user
  ) => {
    this.setState({showLoading: true});
    var status = ["NeverNotify"];
    var travelForecast = {
      journeyPlanId: journeyPlanId,
      selectedJourneyOption: journeyOption,
      journeyOptionId: journeyOption.id,
      userIdentityId: userIdentityId,
      status: status,
    };
    console.log("travelForecastThirdParty:request", travelForecast);

    restServicePost(
      this.props.apiToken,
      "travelForecastThirdParty",
      travelForecast
    )
      .then((response) => {
        console.log("travelForecastThirdParty:response", response.data);
        let thirdPartyURL = journeyOption.thirdPartySource;
        let travelForecastId = "";
        let email = "";

        if (customData) {
          thirdPartyURL = customData.sourceURL;
          travelForecastId = "";
          email = customData.includeEmail ? "&email=" + user.emailAddress : "";
        }
        this.navigate(thirdPartyURL + travelForecastId + email, customData);
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 401) this.props.auth.login();
      });
  };

  checkFirstLogin = (showTravelProfile) => {
    const apimUser = userLocalDataService.getAPIMUser();

    let user = {
      identityEmail: null,
      emailAddress: null,
    };

    user.identityEmail = this.state.thirdPartyAuthenticated
      ? this.state.thirdPartyLogin.email
      : apimUser.identityEmail ?? "";
    user.emailAddress = user.identityEmail;

    restServiceGet(this.props.apiToken, "getLastLogin/" + user.emailAddress)
      .then((response) => {
        if (
          response.data === null ||
          response.data === undefined ||
          response.data === "0001-01-01T00:00:00+00:00"
        ) {
          this.setState({ editProfile: true });
          this.toggleProfile();
        } else {
          if (showTravelProfile) this.setState({ profile: true });
          this.getFilterUserTravelPlans(false);
        }

        restServicePost(
          this.props.apiToken,
          "updateLastLogin/" + user.emailAddress
        ).catch((err) => {
          console.warn("Error updating last login:", err);
        });
        safeLocalStorageService.setItem("loggedIn", true);
      })
      .catch((err) => {
        console.warn("Error getting last login:", err);
      });
  };

  createInitialUserIdentity = () => {
    //For creating a userIdentity due to being logged in to APIM
    const apimUser = userLocalDataService.getAPIMUser();

    let user = {
      identityEmail: null,
      channel: "TravelAssistant",
      firstName: apimUser.firstName ?? "",
      lastName: apimUser.lastName ?? "",
      password: "",
      emailAddress: null,
      selectedOrganisations: null,
      mobilePhoneNumber: "",
      isDayBeforeChecked: false,
      isWeekBeforeChecked: false,
      isDisruptionChecked: false,
      organisationId: null,
      organisationName: "",
    };

    user.identityEmail = this.state.thirdPartyAuthenticated
      ? this.state.thirdPartyLogin.email
      : apimUser.identityEmail ?? "";
    user.emailAddress = user.identityEmail;

    restServiceGet(
      this.props.apiToken,
      "userIdentityByEmail/" + user.identityEmail
    )
      .then((response) => {
        this.updateUserPosition();
        // User found not action required
      })
      .catch((error) => {
        if (error.response?.status === 404) {
          restServicePost(this.props.apiToken, "userIdentityUnsecure", user)
            .then(() => {
              this.createUserProfile();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
  };

  navigate = (href, customData) => {
    this.setState({
      thirdPartyPopUp: true,
      thirdPartyRedirectionURL: href,
      thirdPartyJourneyDetails: customData,
      showLoading: false,
      showInitialLoading: false,
    });
  };

  setJourneysExpanded = (journeyId, expandJourneys) => {
    this.setState((prevState) => {
      return {
        journeys: {
          ...prevState.journeys,
          journeyOptions: prevState.journeys.journeyOptions.map((journey) => {
            if (journey.id === journeyId) {
              journey.subJourneysExpanded = expandJourneys;
            }
            return journey;
          }),
        },
      };
    });
  };

  setReturnJourneysExpanded = (journeyId, expandJourneys) => {
    this.setState((prevState) => {
      return {
        returnJourneys: {
          ...prevState.returnJourneys,
          journeyOptions: prevState.returnJourneys.journeyOptions.map(
            (journey) => {
              if (journey.id === journeyId) {
                journey.subJourneysExpanded = expandJourneys;
              }
              return journey;
            }
          ),
        },
      };
    });
  };

  toggleDisruptionsModal = (toggleDisruptions, disruptionMessages) => {
    this.setState({
      displayDisruptionsModal: toggleDisruptions,
      disruptionMessages: disruptionMessages,
      activeModal: toggleDisruptions ? "disruptionsModal" : null,
    });
    this.setShowBottomSheet(!toggleDisruptions);
  };

  toggleActiveJourney = (journeyIndex) => {
    this.setState((prevState) => {
      var showForm = prevState.showForm;
      var showResults = prevState.showResults;
      var searched = prevState.searched;

      if (journeyIndex === null && showForm) {
        showForm = !showForm;
        showResults = !showResults;
      }

      if (
        prevState.activeJourney === null &&
        journeyIndex === null &&
        showResults
      ) {
        showResults = !showResults;
        searched = false;
      }

      var _journeyOptionID =
        this.state.journeys && this.state.journeys.journeyOptions[journeyIndex]
          ? this.state.journeys.journeyOptions[journeyIndex].id
          : null;

      // When the main journey is changed, stop showing the previous journey's trackpoints.
      var resetActiveLeg = prevState.activeJourney !== journeyIndex;

      const selectedJourneyOption =
        this.state.journeys.journeyOptions[journeyIndex];
      const startLocation = selectedJourneyOption?.legs?.[0]?.startLocation;
      const endLocation =
        selectedJourneyOption?.legs?.[selectedJourneyOption?.legs?.length - 1]
          ?.endLocation;

      return {
        activeJourney: journeyIndex,
        selectedJourneyOption: selectedJourneyOption,
        originLocation: {
          ...this.state.originLocation,
          location: startLocation,
        },
        destinationLocation: {
          ...this.state.destinationLocation,
          location: endLocation,
        },
        journeyOptionId: _journeyOptionID,
        showForm: showForm,
        showResults: showResults,
        searched: searched,
        activeLeg: resetActiveLeg ? null : prevState.activeLeg,
      };
    });
  };

  toggleActiveReturnJourney = (journeyIndex) => {
    this.setState((prevState) => {
      var showForm = prevState.showForm;
      var showResults = prevState.showResults;

      if (journeyIndex === null && showForm) {
        showForm = !showForm;
        showResults = !showResults;
      }

      if (
        prevState.activeJourney === null &&
        journeyIndex === null &&
        showResults
      ) {
        showResults = !showResults;
      }

      var _returnJourneyOptionId =
        this.state.returnJourneys &&
          this.state.returnJourneys.journeyOptions[journeyIndex]
          ? this.state.returnJourneys.journeyOptions[journeyIndex].id
          : null;

      // When the main journey is changed, stop showing the previous journey's trackpoints.
      var resetActiveLeg = prevState.activeReturnJourney !== journeyIndex;

      const selectedJourneyOption =
        this.state.returnJourneys.journeyOptions[journeyIndex];
      const startLocation = selectedJourneyOption?.legs?.[0]?.startLocation;
      const endLocation =
        selectedJourneyOption?.legs?.[selectedJourneyOption?.legs?.length - 1]
          ?.endLocation;

      return {
        activeReturnJourney: journeyIndex,
        selectedReturnJourneyOption: selectedJourneyOption,
        originLocation: {
          ...this.state.originLocation,
          location: startLocation,
        },
        destinationLocation: {
          ...this.state.destinationLocation,
          location: endLocation,
        },
        returnJourneyOptionId: _returnJourneyOptionId,
        activeLeg: resetActiveLeg ? null : prevState.activeLeg,
      };
    });
  };

  setViewportToJourney = (id, forceReload = false) => {
    console.log(
      "[setViewportToJourney] Called with id:",
      id,
      "forceReload:",
      forceReload
    );
    console.log(
      "[setViewportToJourney] Journey option boundingBox:",
      this.state.journeys.journeyOptions[id].boundingBox
    );

    const boundingBox = this.state.journeys.journeyOptions[id].boundingBox;

    if (!boundingBox) {
      console.log("[setViewportToJourney] No boundingBox available");
      return;
    }

    if (forceReload) {
      // For initial load: calculate viewport and force map re-render
      const newViewport = this.createViewPort(
        boundingBox,
        null, // overrideZoomLevel
        boundingBox.maxZoomLevel || 19, // maxZoomLevel
        50, // mobilePadding
        100, // desktopPadding
        true // isJourneyMap
      );

      // Update both boundingBox and viewport, and force map re-render
      this.setState({
        boundingBox: {
          ...boundingBox,
          zoomLevel: boundingBox.zoomLevel,
          maxZoomLevel: boundingBox.maxZoomLevel || 19,
        },
        viewport: newViewport, // Update viewport to update initialViewState
        updateMap: this.state.updateMap + 1, // Force map re-render with new viewport
      });
    } else {
      // For user interaction: use imperative API without reloading map
      const map = this.reactMap?.getMap?.();
      if (map && map.fitBounds && this.refs.Map?.clientWidth) {
        console.log("[setViewportToJourney] Using fitBounds without reload");

        const padding =
          this.refs.Map.clientWidth < MOBILE_VIEW_THRESHOLD ? 50 : 100;

        map.fitBounds(
          [
            [boundingBox.maxLongitude, boundingBox.maxLatitude],
            [boundingBox.minLongitude, boundingBox.minLatitude],
          ],
          {
            padding: padding,
            duration: 1000,
            maxZoom: boundingBox.maxZoomLevel || 19,
          }
        );

        // Still update boundingBox in state for tracking
        this.setState({
          boundingBox: {
            ...boundingBox,
            zoomLevel: boundingBox.zoomLevel,
            maxZoomLevel: boundingBox.maxZoomLevel || 19,
          },
        });
      }
    }
  };

  toggleSelection = () => {
    this.setState({
      showForm: true,
      showResults: false,
      showLoading: false,
      showInitialLoading: false,
      showLoadingJourneyMessages: false,
    });
  };

  // setDefaultSearchParameters = () => {
  //   if ( this.props.auth.isAuthenticated() ) {
  //     this.getProfileFilters();
  //   }
  // };

  setInitialMap = () => {
    this.setState({
      showResults: false,
      viewportMarker: null,
    });
  };

  setActiveDestinationEventOnMap = (destinationEvent) => {
    if (destinationEvent?.eventId) {
      this.setState(() => {
        return {
          activeDestinationEvent: destinationEvent,
          singleNonMDDestinationEvent: destinationEvent,
        };
      });
    }
  };

  updateDimensions = () => {
    this.setState({width: window.innerWidth});
  };

  handleJourneyLegClicked = (leg, boundingBox) => {
    if (boundingBox) {
      const targetViewport = this.createViewPort(
        {...boundingBox, zoomLevel: 17},
        null,
        17,
        70,
        150,
        true
      );

      // Use map.flyTo for smooth animation (react-map-gl v7+)
      const map = this.reactMap?.getMap?.();
      if (map && targetViewport) {
        map.flyTo({
          center: [targetViewport.longitude, targetViewport.latitude],
          zoom: targetViewport.zoom,
          duration: 1500,
          essential: true,
          easing: (t) => t * (2 - t), // Ease-out quad for smoother deceleration
        });
      }

      this.setState({activeLeg: leg});
    } else {
      this.setState({activeLeg: leg});
    }
  };

  handleLegUpdateClicked = (updatedLegs) => {
    this.setState({legs: updatedLegs});
  };

  handleJourneyClicked = (activeJourneyLegs) => {
    this.setState({activeJourneyLegs: activeJourneyLegs}, () => {
      if (!this.state.travelForecast || !this.state.travelForecastId) {
        this.debouncedtagLastJourneyOptionId(
          this.state.journeys.journeyPlanId,
          this.state.selectedJourneyOption.id
        );

        if (
          !this.state.journeys.journeyPlanId ||
          !this.state.selectedJourneyOption.id
        ) {
          return;
        }

        safeLocalStorageService.setItem(
          "latestJourneyOptionId",
          this.state.selectedJourneyOption.id
        );
      }
    });
  };

  handleReturnJourneyClicked = (activeReturnJourneyLegs) => {
    this.setState({activeReturnJourneyLegs: activeReturnJourneyLegs}, () => {
      if (!this.state.travelForecast || !this.state.travelForecastId) {
        if (
          !this.state.returnJourneys.journeyPlanId ||
          !this.state.selectedReturnJourneyOption.id
        )
          return;
        this.debouncedtagLastJourneyOptionId(
          this.state.returnJourneys.journeyPlanId,
          this.state.selectedReturnJourneyOption.id
        );
      }
    });
  };

  debouncedtagLastJourneyOptionId = _.debounce(
    (journeyPlanId, journeyOptionId) => {
      restServiceGet(
        this.props.apiToken,
        `tagLastSelectedJourneyOption/${journeyPlanId}/${journeyOptionId}`
      )
        .then((response) => {
          // We don't care about the response.
        })
        .catch((err) => {
          console.warn("Error tagging last selected journey option:", err);
        });
    },
    500
  );

  handleItineraryActive = (isItineraryActive) => {
    this.setState({isItineraryActive: isItineraryActive});
  };

  toggleSharing = (fromEditJourney) => {
    if (fromEditJourney) {
      this.setState({sharing: false});
    } else {
      const currentState = this.state.sharing;
      this.setState({sharing: !currentState});
    }
  };

  toggleMenu = () => {
    let show = this.state.menu;
    this.setState({menu: !show, error: false});
    this.setShowBottomSheet(show);
  };

  resetToggleProfile = () => {
    this.setState({profile: false}, function () {
      this.toggleProfile();
    });
  };

  toggleProfile = () => {
    const {profile, thirdPartyAuthenticated, thirdPartyLogin} = this.state;
    const {auth} = this.props;
    const apimUser = userLocalDataService.getAPIMUser();

    this.checkCrossSite();

    if (!profile) {
      this.setState({showLoading: false, showInitialLoading: true});

      const identityEmail = thirdPartyAuthenticated
        ? thirdPartyLogin.email
        : apimUser.identityEmail;

      this.getUserTravelPlans(identityEmail, false);

      if (auth.isAuthenticated() || thirdPartyAuthenticated) {
        this.getProfileFilters();
      }

      this.setState({profile: true, error: false});
    } else {
      this.setState({profile: false, error: false});
    }
  };

  loginOrSaveTravelForecast = (journeyOptionId) => {
    var apimUser = authLocalDataService.getAPIMUser();
    const isAuthenticated = this.props.auth.isAuthenticated();

    if (isAuthenticated) {
      this.postUser(
        {...apimUser, emailAddress: apimUser.identityEmail},
        {
          status: [
            "NotifyDisruption",
            "NotifyMonthBefore",
            "NotifyWeekBefore",
            "NotifyDayBefore",
            "NotifyHourBefore",
          ],
          useWhatsApp: true,
          notificationAutomaticApproval: "",
        },
        journeyOptionId,
        null,
        true
      );
    } else {
      this.handleLoginOperation(this.state.language);
    }
  };

  toggleAssistanceProfileOnConfirmation = () => {
    this.setState({
      showConfirmation: true,
      error: false,
      isAssistanceConfirmation: true,
      profile: false,
      requestAssistance: false,
      showResults: false,
    });
  };

  checkCrossSite = () => {
    var baseUri = safeLocalStorageService.getItem("base_Url");
    var uri = window.location.href;

    if (baseUri !== uri) {
      safeLocalStorageService.setItem("base_Url", uri);
    }
  };

  useCurrentLocation = (travelForecastId) => {
    const setGeoLocation = (position) => {
      if (!position) {
        alert(
          "Location Services are disabled, please enable location services to use the Current Location."
        );
        return;
      }
      console.log(position);
      this.toggleRequestAssistance(
        travelForecastId,
        position.coords !== undefined ? position.coords : position
      );
    };

    const position = geolocationService.getCurrentPosition();
    if (position) {
      setGeoLocation(position);
    } else {
      var notAlowedPosition = {
        coords: {
          latitude: 0,
          longitude: 0,
        },
      };
      this.toggleRequestAssistance(travelForecastId, notAlowedPosition.coords);
    }
  };

  toggleRequestAssistance = (travelForecastId, position) => {
    if (this.state.profileId === null) {
      //GetProfileFilters run as part of componentDidMount
      this.createUserProfile();
    }
    let show = this.state.requestAssistance;
    this.setState({
      requestAssistance: show ? false : true,
      error: false,
      travelForecastId,
      currentPosition: position,
    });
  };

  toggleAssistanceConfirmation = (userId) => {
    restServicePut(this.props.apiToken, "confirmProfile/" + userId)
      .then(() => {
        this.setState({showConfirmation: true, ConfirmedAssistance: true});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggleConfirmation = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const travelForecastId = searchParams.get("travelplanid");
    if (travelForecastId) {
      this.setState({
        showConfirmation: true,
        showResults: false,
        error: false,
      });
      this.toggleRequestAssistance(null);
      return;
    }

    let show = this.state.showConfirmation;
    this.setState({
      showConfirmation: show ? false : true,
      error: false,
      isAssistanceConfirmation: true,
    });
    this.toggleRequestAssistance(null);
    this.toggleProfile();
  };

  getPreviousTravelPlan = (travelPlanId, groupName) => {
    const url = `${window.location.origin}/${groupName}/travelplan?travelplanid=${travelPlanId}`;
    const searchParams = new URLSearchParams(window.location.search);
    const isAssistanceRequested = searchParams.get("assist") === "true";
    window.location.href = isAssistanceRequested ? url + "&assist=true" : url;
  };

  logout = () => {
    this.props.auth.logout();
    safeLocalStorageService.setItem("loggedIn", false);
  };

  setActiveDestinationEventSelectedOnMap = (destinationEvent) => {
    if (destinationEvent !== null && destinationEvent?.eventId) {
      // Smoothly center on the clicked marker
      try {
        const map = this.reactMap?.getMap?.();
        const {lat, lng, valid} = parseAndValidateLngLat(
          destinationEvent?.location?.longitude,
          destinationEvent?.location?.latitude
        );
        if (map && valid) {
          map.easeTo({center: [lng, lat], duration: 700});
        }
      } catch (_) { }

      this.setState({
        clickedPreviousDestinationEvent: this.state.activeDestinationEvent,
        activeDestinationEvent: destinationEvent,
        destinationEventSelectedOnMap: destinationEvent,
        markerPopup: true,
        destinationChangeStamp: new Date(),
        selectedReturnDateTime: destinationEvent?.endTime
          ? moment(destinationEvent?.endTime)
          : this.state.selectedReturnDateTime,
      });
    }
  };

  setActiveTrafficSelectedOnMap = (trafficObject) => {
    if (trafficObject != null) {
      const {lat, lng, valid} = parseAndValidateLngLat(
        trafficObject.groupOfLocations.tpegPointLocation.point.pointCoordinates
          .longitude,
        trafficObject.groupOfLocations.tpegPointLocation.point.pointCoordinates
          .latitude
      );
      try {
        const map = this.reactMap?.getMap?.();
        if (map && valid) {
          map.easeTo({center: [lng, lat], duration: 700});
        }
      } catch (_) { }

      this.setState({
        activeTrafficObject: trafficObject,
        markerTrafficPopup: true,
      });
    }
  };

  getPolyLineEventFromMap = (event) => {
    console.log(event);
    const _polyPopUp = {...this.state.PolyPopUp};
    _polyPopUp.longitude = event.lngLat.lng;
    _polyPopUp.latitude = event.lngLat.lat;
    _polyPopUp.content =
      this.state.lineDatas[
        event.features[0].source.toString().split("_")[1]
      ].description;

    this.setState({
      showPolyPopUp: !this.state.showPolyPopUp,
      PolyPopUp: _polyPopUp,
    });
  };

  togglePolyPopUp = (polyPopUp) => {
    this.setState({
      showPolyPopUp: !this.state.showPolyPopUp,
      PolyPopUp: polyPopUp,
    });
  };

  setJourneyPlanUpdated = (
    assistantPosition,
    position,
    assistantPosDesc,
    requestorPosDesc
  ) => {
    var journeyPlan = {
      startLocation: {
        latitude: assistantPosition.latitude,
        longitude: assistantPosition.longitude,
        description: assistantPosDesc,
      },
      endLocation: {
        latitude: position.coordinates[1],
        longitude: position.coordinates[0],
        description: requestorPosDesc,
      },
      departureTime: moment.parseZone(),
    };
    this.setState({
      startLocation: journeyPlan.startLocation,
      endLocation: journeyPlan.endLocation,
      initOperations: true,
    });

    console.log(journeyPlan);

    var filters;
    filters = this.getProfileFilters();

    if (!filters) {
      filters = {
        ...defaultFilters,
        startLocation: journeyPlan.startLocation,
        endLocation: journeyPlan.endLocation,
      };
    }
    console.log("Filters", filters);

    this.setState({
      startLocation: journeyPlan.startLocation,
      endLocation: journeyPlan.endLocation,
    });

    this.postJourneyOptions(journeyPlan, filters, true);
  };

  updateCloseCallBack = () => {
    this.setState({markerPopup: false});
  };

  updateTrafficPopupCloseCallBack = () => {
    this.setState({markerTrafficPopup: false});
  };
  setChargeWayPoint = (chargePointDestination) => {
    this.setState({chargeWayPoint: chargePointDestination});
  };

  handleLoginOperation = (lang) => {
    // const embeddedOniFrame = window.location !== window.parent.location;
    // if (
    //   !embeddedOniFrame ||
    //   (embeddedOniFrame && this.state.isCrossSiteChecked && this.state.crossSite === "enabled")
    // ) {
    safeLocalStorageService.setItem("isLoggingIn", true);
    this.props.auth.login(lang);
    // } else {
    //   this.crossSiteValidationOperation();
    //   this.setState({ showCrossSiteWarning: true });
    // }
  };

  handleDisruptionChange = () => {
    this.setState({
      showEVCluster: !this.state.showEVCluster,
    });
  };

  lockUnlockMap = () => {
    this.setState({
      mapLocked: !this.state.mapLocked,
    });
  };

  switchTrafficForecast = () => {
    if (!this.state.trafficForecast) {
      this.getTrafficForecast();
    } else {
      this.setState({
        trafficData: [],
        showLoading: false,
        showInitialLoading: false,
        showLoadingJourneyMessages: false,
        showForm: false,
        mapNotReadyToRender: false,
      });
    }
    this.setState({
      trafficForecast: !this.state.trafficForecast,
    });
  };

  handleTimeChange = (selectedDateTime) => {
    this.setState({
      selectedDateTime,
    });
  };

  handleReturnTimeChange = (selectedReturnDateTime) => {
    this.setState({
      selectedReturnDateTime,
    });
  };

  markerOptionsAction = (index) => {
    //Toggle the markerOption isFocused, and let the component handle the rest
    this.setState((prevState) => {
      return {
        markerOptions: prevState.markerOptions.map((markerOption, curIndex) => {
          return {
            ...markerOption,
            isFocused:
              curIndex === index
                ? !markerOption.isFocused
                : markerOption.isFocused,
          };
        }),
      };
    });
  };

  getTrafficForecast = () => {
    restServiceGet(
      this.props.apiToken,
      "disruption/bd8e38d6-3175-6e80-13d5993e9122"
    )
      .then((response) => {
        var trafficDataTemp = [];
        response.data.forEach(function (entry) {
          entry.situationRecord.forEach((element) => {
            trafficDataTemp.push(element);
          });
        });

        this.setState({
          trafficData: [...this.state.trafficData, ...trafficDataTemp],
          showLoading: false,
          showInitialLoading: false,
          showLoadingJourneyMessages: false,
          showForm: false,
          mapNotReadyToRender: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          showForm: false,
        });
      });
  };

  handleAccessibility = () => {
    const script = document.createElement("script");
    script.setAttribute("data-account", "gXKL7gvqmQ");
    script.setAttribute("src", "https://cdn.userway.org/widget.js");
    script.async = true;

    document.body.appendChild(script);

    this.setState({isUserWayActive: true});
  };

  setShowBottomSheet = (shouldShow) => {
    const isMobile = window.innerWidth <= MOBILE_VIEW_THRESHOLD;
    if (isMobile) {
      this.setState({showBottomSheet: shouldShow});
    }
  };

  setBottomSheetPosition = (newPosition) => {
    this.bottomSheetRef.current?.snapTo(newPosition);
  };

  _renderAddNotification = () => {
    const {showForm} = this.state;
    return (
      showForm && (
        <>
          <div className={styles["buffer"]} />
          <AddNotification
            organisation={this.state.organisation}
            journeyOptionId={
              this.state.journeys.journeyOptions[this.state.activeJourney].id
            }
            callbackFromParent={this.postUser}
            auth={this.props.auth}
            consent={this.state.consentStatement}
          />
        </>
      )
    );
  };

  _renderErrorMessage = () => {
    const {error, errorType, errorMessage} = this.state;
    return (
      error && (
        <Error
          errorType={errorType}
          errorMessage={errorMessage}
          setStartLocation={() => {
            this.setState({
              triggerStartLocationRefresh:
                !this.state.triggerStartLocationRefresh,
            });
          }}
          setTimeNow={() => {
            this.setState({
              triggerDateTimeRefresh: !this.state.triggerDateTimeRefresh,
            });
          }}
        />
      )
    );
  };

  _renderConfirmation = () => {
    const {showConfirmation, ConfirmedAssistance, isAssistanceConfirmation} =
      this.state;
    return (
      showConfirmation && (
        <Confirmation
          destinationGroupShortCode={
            this.state.destinationGroupShortCode
              ? "/" + this.state.destinationGroupShortCode
              : "/" + this.state.destinationGroup?.shortCode
          }
          isAssistanceConfirmation={isAssistanceConfirmation}
          ConfirmedAssistance={ConfirmedAssistance}
        />
      )
    );
  };

  _renderCrossSiteWarning = () => {
    const {showCrossSiteWarning} = this.state;
    return (
      showCrossSiteWarning && (
        <CrossSiteWarning handleWarningClose={this.closeCrossSiteWarning} />
      )
    );
  };

  _renderThirdPartyPopup = () => {
    const {
      thirdPartyPopUp,
      thirdPartyRedirectionURL,
      thirdPartyJourneyDetails,
    } = this.state;
    return (
      thirdPartyPopUp && (
        <RedirectionPopup
          redirectionURL={thirdPartyRedirectionURL}
          popUpContent={thirdPartyJourneyDetails}
          handlePopupClose={() =>
            this.setState({
              thirdPartyPopUp: false,
              thirdPartyRedirectionURL: null,
              thirdPartyJourneyDetails: null,
            })
          }
        />
      )
    );
  };

  _renderInfoPopup = () => {
    const {infoPopup, infoContent} = this.state;
    return (
      infoPopup && (
        <InfoPopup
          popUpContent={infoContent}
          handlePopupClose={() =>
            this.setState({
              infoPopup: false,
              infoContent: "",
            })
          }
        />
      )
    );
  };

  _renderSessionManagement = () => {
    const {organisation, destinationGroup} = this.state;

    if (
      !organisation ||
      !destinationGroup ||
      !organisation.isSessionTrackingEnabled
    )
      return null;

    const searchParams = new URLSearchParams(window.location.search);
    const utmParams = {
      utm_source: searchParams.get("utm_source") || "",
      utm_medium: searchParams.get("utm_medium") || "",
      utm_campaign: searchParams.get("utm_campaign") || "",
      utm_term: searchParams.get("utm_term") || "",
      utm_content: searchParams.get("utm_content") || "",
    };

    return (
      <SessionManagement
        organisation={organisation}
        destinationGroup={destinationGroup}
        utmParams={utmParams}
        restServicePost={restServicePost}
        apiToken={this.props.apiToken}
      />
    );
  };

  showInfoPopup = (info) => {
    this.setState({infoPopup: true, infoContent: info});
  };

  _renderEditJourney = () => {
    const {
      showConfirmation,
      searched,
      destinationEvents,
      showResults,
      activeJourney,
      showForm,
      showVia1,
      isEvDestinationGroup,
      isPTOptions,
      showLoading,
    } = this.state;

    const selectedLeg =
      this.state?.activeJourneyLegs?.[this.state.selectedLegIndex];

    const selectedReturnLeg =
      this.state?.activeReturnJourneyLegs?.[this.state.selectedLegIndex];

    return (
      !showConfirmation && (
        <EditJourney
          apiToken={this.props.apiToken}
          postJourneyOptions={this.postJourneyOptions}
          postReturnJourneyOptions={this.postReturnJourneyOptions}
          toggleSelection={this.toggleSelection}
          complete={searched}
          showButton={showResults && activeJourney !== null}
          showCurrentLocation={this.getCurrentPosition}
          toggleMarker={this.setActiveDestinationEventOnMap}
          destinationEvents={destinationEvents}
          showForm={showForm}
          showVia1={showVia1}
          isEvDestinationGroup={isEvDestinationGroup}
          isPTOptions={isPTOptions}
          publicTransportationOptions={this.state.publicTransportationOptions}
          mapFocusActived={this.state.mapFocusActived}
          handleTimeChange={this.handleTimeChange}
          handleReturnTimeChange={this.handleReturnTimeChange}
          lang={this.state.language}
          filters={this.state.filters}
          profilefilters={this.state.profilefilter}
          auth={this.props.auth}
          showTravelPlan={this.state.showTravelPlan}
          handleItineraryActive={this.handleItineraryActive}
          showProfile={this.toggleProfile}
          showMenu={this.toggleMenu}
          handleLoginOperation={(lang) => {
            this.handleLoginOperation(lang);
          }}
          toggleSharepage={this.toggleSharing}
          defaultFrom={this.state.defaultFrom}
          defaultTo={this.state.defaultTo}
          organisation={this.state.organisation}
          disableGoogleSuggestionList={this.state.disableGoogleSuggestionList}
          suggestionSource={
            this.state.autoCompleteParams?.autoCompleteSource ?? "google"
          }
          suggestionApproximateLocation={this.state.viewport}
          journeyPlanBtntxt={this.state.journeyPlanButtonTxt}
          destinationGroupId={this.state.destinationGroup?.id}
          isItineraryEnabled={this.state.itineraryEnabled}
          autoCompleteParams={
            this.state.autoCompleteParams !== null ||
              this.state.autoCompleteParams !== undefined
              ? this.state.autoCompleteParams
              : null
          }
          journeyPlanId={this.state.journeyPlanId}
          travelPlanId={this.state.travelPlanID}
          departureTime={this.state.departureTime}
          arrivalTime={this.state.arrivalTime}
          returnDepartureTime={this.state.returnDepartureTime}
          returnArrivalTime={this.state.returnArrivalTime}
          setInitialMap={this.setInitialMap}
          initOperations={this.state.initOperations}
          destinationChangeStamp={this.state.destinationChangeStamp}
          setCheckForUpdates={(toValue) => {
            this.setState({isCheckForUpdate: toValue});
          }}
          isCheckForUpdate={this.state.isCheckForUpdate}
          hideEditProfile={this.hideEditProfile}
          toggleEditProfile={this.toggleEditProfile}
          editProfile={this.state.editProfile}
          startLocation={this.state.startLocation}
          endLocation={this.state.endLocation}
          setTerminateLegAnimation={this.setTerminateLegAnimation}
          showMarkerModal={this.state.showMarkerModal}
          toggleMarkerModal={this.toggleMarkerModal}
          showDirectionsModal={this.state.showDirectionsModal}
          showIntermediateStops={this.state.showIntermediateStops}
          selectedLeg={selectedLeg}
          selectedReturnLeg={selectedReturnLeg}
          toggleDirectionsModal={this.toggleDirectionsModal}
          toggleIntermediateStopsModal={this.toggleIntermediateStopsModal}
          markerOptions={this.state.markerOptions}
          markerOptionsAction={this.markerOptionsAction}
          setViewport={this.setViewport}
          setViewportAndMarker={this.setViewportAndMarker}
          isTrafficForecastAvailable={this.state.isTrafficForecastAvailable}
          trafficForecast={this.state.trafficForecast}
          switchTrafficForecast={this.switchTrafficForecast}
          showLoading={showLoading}
          showLoadingJourneyMessages={this.state.showLoadingJourneyMessages}
          autoCompleteCustomPlaces={this.state.autoCompleteCustomPlaces}
          locationDropDownOpen={this.state.locationDropDownOpen}
          setLocationDropDownOpen={(setFunc, callback) => {
            this.setState((prev) => {
              return {
                locationDropDownOpen: setFunc(prev.locationDropDownOpen),
              };
            }, callback);
          }}
          setAlertsButton={this.setAlertsButton}
          alertsButtonDisabled={this.state.alertsButtonDisabled}
          hideButtons={this.state.hideEditJourneyButtons}
          resetViewportMarker={this.resetViewportMarker}
          selectedReturnDateTime={this.state.selectedReturnDateTime}
          showReturnButton={this.context.showReturnButton}
          showReturn={this.state.showReturn}
          activeDestinationEvent={this.state.activeDestinationEvent}
          setIsReturn={this.setIsReturn}
          isReturn={this.state.isReturn}
          setShowReturn={this.setShowReturn}
          hasReturnJourneys={this.state.returnJourneys?.journeyPlanId}
          handleUpdateMarkerOptions={this.handleUpdateMarkerOptions}
          isItineraryActive={this.state.isItineraryActive}
          clearReturnJourneys={this.clearReturnJourneys}
          isUserWayActive={this.state.isUserWayActive}
          triggerStartLocationRefresh={this.state.triggerStartLocationRefresh}
          fromPlaceholderText={this.state.destinationGroup?.fromPlaceholderText}
          toPlaceholderText={this.state.destinationGroup?.toPlaceholderText}
          activeModal={this.state.activeModal}
          setActiveModal={this.setActiveModal}
          setShowBottomSheet={this.setShowBottomSheet}
          setBottomSheetPosition={this.setBottomSheetPosition}
        />
      )
    );
  };

  _renderJourneyCollection = () => {
    const {
      showResults,
      journeys,
      returnJourneys,
      activeJourney,
      activeLeg,
      activeReturnJourney,
    } = this.state;

    const isMobile = window.innerWidth <= MOBILE_VIEW_THRESHOLD;

    return (
      !isMobile &&
      showResults &&
      journeys && (
        <JourneyCollection
          journeys={journeys}
          returnJourneys={returnJourneys}
          showReturn={this.state.showReturn}
          isReturn={this.state.isReturn}
          setShowReturn={this.setShowReturn}
          departureTime={this.state.departureTime}
          arrivalTime={this.state.arrivalTime}
          returnArrivalTime={this.state.returnArrivalTime}
          returnDepartureTime={this.state.returnDepartureTime}
          activeJourney={activeJourney}
          activeLeg={activeLeg}
          activeReturnJourney={activeReturnJourney}
          enableNavigation={this.state.isEnableNavigation}
          toggleActiveJourney={this.toggleActiveJourney}
          toggleActiveReturnJourney={this.toggleActiveReturnJourney}
          setViewportToJourney={this.setViewportToJourney}
          onJourneyLegClicked={this.handleJourneyLegClicked}
          onJourneyClicked={this.handleJourneyClicked}
          onReturnJourneyClicked={this.handleReturnJourneyClicked}
          onLegUpdateClicked={this.handleLegUpdateClicked}
          thirdPartyData={this.state.thirdPartyData}
          apiToken={this.props.apiToken}
          toggleSelection={this.toggleSelection}
          showTravelPlan={this.state.showTravelPlan}
          travelForecast={this.state.travelForecast}
          toggleRequestAssistance={this.toggleRequestAssistance}
          auth={this.props.auth}
          restServicePost={restServicePost}
          itineraryEnabled={this.state.itineraryEnabled}
          showInfoPopup={this.showInfoPopup}
          setJourneysExpanded={this.setJourneysExpanded}
          setReturnJourneysExpanded={this.setReturnJourneysExpanded}
          displayDisruptionsModal={this.state.displayDisruptionsModal}
          toggleDisruptionsModal={this.toggleDisruptionsModal}
          terminateLegAnimation={this.state.terminateLegAnimation}
          setTerminateLegAnimation={this.setTerminateLegAnimation}
          toggleDirectionsModal={this.toggleDirectionsModal}
          toggleIntermediateStopsModal={this.toggleIntermediateStopsModal}
          isIntermediateStopsVisible={this.state.isIntermediateStopsVisible}
          setSelectedLegIndex={this.setSelectedLegIndex}
          selectedLegIndex={this.state.selectedLegIndex}
          locationDropDownOpen={this.state.locationDropDownOpen}
          setAlertsButton={this.setAlertsButton}
          alertsButtonDisabled={this.state.alertsButtonDisabled}
          activeTimeTarget={this.state.activeTimeTarget}
          clearActiveTrackpoints={() => {
            this.setState({activeLeg: null, selectedLegIndex: null});
          }}
          selectedReturnDateTime={this.state.selectedReturnDateTime}
          activeDestinationEvent={this.state.activeDestinationEvent}
          loginOrSaveTravelForecast={this.loginOrSaveTravelForecast}
        />
      )
    );
  };

  _renderJourneyCollectionBottomSheet = () => {
    const {
      showResults,
      journeys,
      returnJourneys,
      activeJourney,
      activeLeg,
      activeReturnJourney,
      showBottomSheet,
    } = this.state;

    const isMobile = window.innerWidth <= MOBILE_VIEW_THRESHOLD;

    const selectedJourneyIndex = journeys?.journeyOptions?.findIndex(
      (journey) => journey.highlight
    );

    const isShowingJourney = journeys?.journeyOptions?.some(
      (journey) => journey.active && journey.highlight
    );

    const hasActiveLeg = !!this.state.activeLeg;

    var modalBackgroundColour;
    modalBackgroundColour =
      selectedJourneyIndex === 0 || isShowingJourney ? "#f8f8f8" : "#ffffff";
    modalBackgroundColour = hasActiveLeg ? "#ffffff" : modalBackgroundColour;
    modalBackgroundColour = this.state.isReturn
      ? "#dddddd"
      : modalBackgroundColour;

    const calculateSnapPoints = (headerEnabled, maxHeight) => {
      const closed = 60;
      const min = 180;
      const mid = Math.max(
        min,
        headerEnabled ? (maxHeight + 29) * 0.4 : maxHeight * 0.4
      );
      const max = Math.max(
        min,
        headerEnabled ? maxHeight - 271 : maxHeight - 229
      );

      const snapPoints = {
        closed,
        min,
        mid,
        max,
        headerEnabled,
      };

      return snapPoints;
    };

    return (
      isMobile &&
      showResults &&
      journeys &&
      showBottomSheet && (
        <ThemeContext.Consumer>
          {(theme) => (
            <BottomSheet
              ref={this.bottomSheetRef}
              open={true}
              snapPoints={({maxHeight}) => {
                const maxSheetHeightToUse = maxHeight ? maxHeight : 0;

                const {closed, min, mid, max} = calculateSnapPoints(
                  theme.theme?.isHeaderEnabled,
                  maxSheetHeightToUse
                );

                return [closed, min, mid, max];
              }}
              defaultSnap={180}
              snap={true}
              expandOnContentDrag={true}
              scrollLocking={false}
              blocking={false}
              skipInitialTransition={false}
              style={{
                "--rsbs-bg": modalBackgroundColour,
              }}
            >
              <div
                style={{
                  marginTop: "30px",
                  marginBottom: "30px",
                  height: "auto",
                }}
              >
                <JourneyCollection
                  journeys={journeys}
                  returnJourneys={returnJourneys}
                  showReturn={this.state.showReturn}
                  isReturn={this.state.isReturn}
                  setShowReturn={this.setShowReturn}
                  departureTime={this.state.departureTime}
                  arrivalTime={this.state.arrivalTime}
                  returnArrivalTime={this.state.returnArrivalTime}
                  returnDepartureTime={this.state.returnDepartureTime}
                  activeJourney={activeJourney}
                  activeLeg={activeLeg}
                  activeReturnJourney={activeReturnJourney}
                  enableNavigation={this.state.isEnableNavigation}
                  toggleActiveJourney={this.toggleActiveJourney}
                  toggleActiveReturnJourney={this.toggleActiveReturnJourney}
                  setViewportToJourney={this.setViewportToJourney}
                  onJourneyLegClicked={this.handleJourneyLegClicked}
                  onJourneyClicked={this.handleJourneyClicked}
                  onReturnJourneyClicked={this.handleReturnJourneyClicked}
                  onLegUpdateClicked={this.handleLegUpdateClicked}
                  thirdPartyData={this.state.thirdPartyData}
                  apiToken={this.props.apiToken}
                  toggleSelection={this.toggleSelection}
                  showTravelPlan={this.state.showTravelPlan}
                  travelForecast={this.state.travelForecast}
                  toggleRequestAssistance={this.toggleRequestAssistance}
                  auth={this.props.auth}
                  restServicePost={restServicePost}
                  itineraryEnabled={this.state.itineraryEnabled}
                  showInfoPopup={this.showInfoPopup}
                  setJourneysExpanded={this.setJourneysExpanded}
                  setReturnJourneysExpanded={this.setReturnJourneysExpanded}
                  displayDisruptionsModal={this.state.displayDisruptionsModal}
                  toggleDisruptionsModal={this.toggleDisruptionsModal}
                  terminateLegAnimation={this.state.terminateLegAnimation}
                  setTerminateLegAnimation={this.setTerminateLegAnimation}
                  toggleDirectionsModal={this.toggleDirectionsModal}
                  toggleIntermediateStopsModal={
                    this.toggleIntermediateStopsModal
                  }
                  isIntermediateStopsVisible={
                    this.state.isIntermediateStopsVisible
                  }
                  setSelectedLegIndex={this.setSelectedLegIndex}
                  selectedLegIndex={this.state.selectedLegIndex}
                  locationDropDownOpen={this.state.locationDropDownOpen}
                  setAlertsButton={this.setAlertsButton}
                  alertsButtonDisabled={this.state.alertsButtonDisabled}
                  activeTimeTarget={this.state.activeTimeTarget}
                  clearActiveTrackpoints={() => {
                    this.setState({activeLeg: null, selectedLegIndex: null});
                  }}
                  selectedReturnDateTime={this.state.selectedReturnDateTime}
                  activeDestinationEvent={this.state.activeDestinationEvent}
                />
              </div>
            </BottomSheet>
          )}
        </ThemeContext.Consumer>
      )
    );
  };

  convertJourneysToPolylines = (journeys) => {
    return journeys.journeyOptions.map((journey) => {
      return journey.legs.flatMap((leg) => {
        return {
          isDotted: leg?.isPolylinePlaceholder || leg?.mode === "Walk",
          // Ensure coordinates are valid numbers; Mapbox GL requires numeric lng/lat.
          // We also filter out any invalid values to avoid silent render failures
          // where lines sometimes don’t appear until a zoom/refresh.
          trackpoints:
            leg.trackpoints
              ?.map((point) => {
                const {lat, lng, valid} = parseAndValidateLngLat(
                  point.longitude,
                  point.latitude
                );
                return valid ? [lng, lat] : null;
              })
              .filter((p) => Array.isArray(p)) || [],
        };
      });
    });
  };

  getLineData = (coordinates) => {
    return {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: coordinates,
      },
    };
  };

  renderRoute = (name, routes, themeColor) => {
    // Add safety check: only render if we have valid map reference and style is loaded
    if (!this.state.styleLoaded || !this.reactMap?.getMap?.()) {
      return null;
    }

    return routes.map((route, index) =>
      route.map((routeObj, subIndex) => [
        <Source
          key={`${name}routeData${index}-${subIndex}`}
          id={`${name}routeData${index}-${subIndex}`}
          type="geojson"
          data={this.getLineData(routeObj.trackpoints)}
        />,
        <Layer
          key={`${name}route${index}-${subIndex}`}
          id={`${name}route${index}-${subIndex}`}
          type="line"
          source={`${name}routeData${index}-${subIndex}`}
          layout={{
            visibility:
              name === "main"
                ? index === this.state.activeJourney
                  ? "visible"
                  : "none"
                : index === this.state.activeReturnJourney
                  ? "visible"
                  : "none",
            "line-join": "round",
            "line-cap": "round",
          }}
          paint={{
            "line-color": themeColor,
            "line-width":
              (name === "main" && !this.state.showReturn) ||
                (name === "return" && this.state.showReturn)
                ? 8
                : 0, // Don't show the return line!
            "line-opacity": 0.8,
            "line-dasharray": routeObj.isDotted ? [1, 2] : [1, 0],
          }}
        />,
      ])
    );
  };

  _renderJourneyPolylines = () => {
    const {journeys, returnJourneys} = this.state;
    const isReturn = !!returnJourneys?.journeyPlanId;
    const routes = this.convertJourneysToPolylines(journeys);
    var returnRoutes;
    if (isReturn) {
      returnRoutes = this.convertJourneysToPolylines(returnJourneys);
    }

    return (
      <ThemeContext.Consumer>
        {(theme) => (
          <>
            {this.renderRoute(
              "main",
              routes,
              this.state.showReturn ? "#808080" : theme.theme.polylineColour
            )}
            {isReturn &&
              this.renderRoute(
                "return",
                returnRoutes,
                this.state.showReturn ? theme.theme.polylineColour : "#808080"
              )}
          </>
        )}
      </ThemeContext.Consumer>
    );
  };

  _renderPolylines = () => {
    // Add safety check: only render if we have valid map reference and style is loaded
    if (!this.state.styleLoaded || !this.reactMap?.getMap?.()) {
      return null;
    }

    return (
      this.state.lineDatas !== undefined &&
      this.state.lineDatas.map((lineData, index) => {
        return [
          <Source
            id={"Source_" + index}
            type="geojson"
            data={lineData}
          />,
          <Layer
            key={index}
            id={"Source_" + index}
            type="line"
            dataModel={lineData}
            source={"Source_" + index}
            onClick={(event) => this.getPolyLineEventFromMap(event)}
            layout={{
              "line-join": "round",
              "line-cap": "round",
            }}
            paint={{
              "line-color": lineData.color,
              "line-width": 8,
              "line-opacity": 1,
            }}
          />,
        ];
      })
    );
  };

  _renderCurrentLocation = () => {
    if (!this.state.currentPosition) {
      return;
    }

    const {lat, lng, valid} = parseAndValidateLngLat(
      this.state.currentPosition.longitude,
      this.state.currentPosition.latitude
    );
    if (!valid || (lat === 0 && lng === 0)) {
      return;
    }

    return (
      <Marker
        latitude={lat}
        longitude={lng}
        offsetLeft={-20}
        offsetTop={-40}
      >
        <CurrentLocation colour="#FF0000" />
      </Marker>
    );
  };

  _renderPolylinePopUp = () => {
    return (
      <Popup
        longitude={this.state.PolyPopUp.longitude}
        latitude={this.state.PolyPopUp.latitude}
        closeButton={false}
        closeOnClick={false}
      >
        {this.state.PolyPopUp.content}
      </Popup>
    );
  };

  _renderSelectedLocations = () => {
    const {originLocation, destinationLocation} = this.state;
    const markers = [originLocation, destinationLocation];

    return markers
      .filter((marker) => {
        if (!marker?.location) return false;
        const {valid} = parseAndValidateLngLat(
          marker.location.longitude,
          marker.location.latitude
        );
        return valid;
      })
      .map((marker, index) => {
        const {lat: latitude, lng: longitude} = parseAndValidateLngLat(
          marker.location.longitude,
          marker.location.latitude
        );
        const key = marker.id ?? `marker-${index}`;

        return (
          <Marker
            key={key}
            latitude={latitude}
            longitude={longitude}
            offsetLeft={-20}
            offsetTop={-40}
          >
            <LocationOn
              data-cy="markers"
              className={styles.LocationOn}
              onClick={() => this.onClickMarker(marker)}
            />
          </Marker>
        );
      });
  };

  _renderViewportMarker = () => {
    if (this.state.viewportMarker) {
      const {lat, lng, valid} = parseAndValidateLngLat(
        this.state.viewportMarker.longitude,
        this.state.viewportMarker.latitude
      );
      if (!valid) {
        return null;
      }
      return (
        <>
          <Marker
            key={999}
            latitude={lat}
            longitude={lng}
            offsetLeft={-20}
            offsetTop={-40}
          >
            <LocationOn
              data-cy={"markers"}
              className={styles["LocationOn"]}
            />
          </Marker>
        </>
      );
    }
  };

  resetViewportMarker = () => {
    this.setState({
      viewportMarker: null,
    });
  };

  onClickMarker = (destinationEvent) => {
    this.setState({
      activeDestinationEvent: destinationEvent,
      clickedPreviousDestinationEvent: this.state.activeDestinationEvent,
      markerPopup: true,
    });
  };

  _renderActivePolyline = () => {
    if (!this.state.activeLeg) {
      return;
    }

    // Add safety check: only render if we have valid map reference and style is loaded
    if (!this.state.styleLoaded || !this.reactMap?.getMap?.()) {
      return null;
    }

    var activeTrackCoordinates = [];
    if (this.state.activeLeg != null) {
      this.state.activeLeg.trackpoints.forEach((trackpoint) => {
        activeTrackCoordinates.push([
          trackpoint.longitude,
          trackpoint.latitude,
        ]);
      });
    }

    return (
      <ThemeContext.Consumer>
        {(theme) => (
          <React.Fragment key={"activeTrackWrapper"}>
            <Source
              key={"activeTrackData"}
              id="activeTrackData"
              type="geojson"
              data={this.getLineData(activeTrackCoordinates)}
            />
            <Layer
              key={"activeTrack"}
              id={"activeTrack"}
              type="line"
              source="activeTrackData"
              layout={{
                visibility: "visible",
                "line-join": "round",
                "line-cap": "round",
              }}
              paint={{
                "line-color": theme.theme.activePolylineColour,
                "line-width": 8,
                "line-opacity": 1,
                "line-dasharray":
                  this.state.activeLeg.mode === "Walk" ? [1, 2] : [1, 0],
              }}
            />
          </React.Fragment>
        )}
      </ThemeContext.Consumer>
    );
  };

  // Render traffic markers with clustering using the shared ClusterHandler.
  // The previous implementation attempted to use a Marker component as a
  // cluster wrapper, which swallowed its children and resulted in no traffic
  // markers rendering locally. We now register traffic markers with
  // ClusterHandler so they render and cluster consistently.
  _renderTrafficData = () => {
    if (!this.state.trafficForecast || !this.state.trafficData?.length)
      return null;

    return (
      <ClusterHandler
        onClickCluster={this.onClickCluster}
        clusterMarkerComponent={ClusterTrafficMarker}
      >
        {/* ClusterHandler consumes registered markers via context and renders
            either clusters (ClusterTrafficMarker via ClusterHandler) or the
            original Marker element. We only need to register our markers. */}
        <TrafficClusterGroup
          trafficData={this.state.trafficData}
          setActiveTrafficSelectedOnMap={this.setActiveTrafficSelectedOnMap}
        />
      </ClusterHandler>
    );
  };

  isWithin100m = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // Radius of the earth in km
    var dLat = (lat2 - lat1) * (Math.PI / 180); // deg2rad below
    var dLon = (lon2 - lon1) * (Math.PI / 180);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in KM.
    if (d > 0.1) return true;
    return false;
  };

  _renderPolylineIcons = () => {
    const journeyLegsToRenderIconsFrom = this.state.showReturn
      ? this.state.activeReturnJourneyLegs
      : this.state.activeJourneyLegs;

    if (!journeyLegsToRenderIconsFrom) return;
    return journeyLegsToRenderIconsFrom.map((leg, index) => {
      const {trackpoints, startLocation, endLocation, mode} = leg;

      let latitude =
        trackpoints.length > 0
          ? parseFloat(trackpoints[Math.floor(trackpoints.length / 2)].latitude)
          : parseFloat(startLocation.latitude);
      let longitude =
        trackpoints.length > 0
          ? parseFloat(
            trackpoints[Math.floor(trackpoints.length / 2)].longitude
          )
          : parseFloat(startLocation.longitude);

      // Render the flight icon at the start of the leg as the data given is insufficient to accurately
      // render it at the midpoint of the line.
      if (leg.mode === "Flight") {
        latitude = parseFloat(startLocation.latitude);
        longitude = parseFloat(startLocation.longitude);
      }

      const {lat, lng, valid} = parseAndValidateLngLat(longitude, latitude);
      if (!valid) return "";

      const distance = this.isWithin100m(
        lat,
        lng,
        endLocation.latitude,
        endLocation.longitude
      );

      return index < journeyLegsToRenderIconsFrom.length - 1 || distance ? (
        <Marker
          key={index}
          latitude={lat}
          longitude={lng}
          offsetLeft={-10}
          offsetTop={-10}
        >
          {this._renderTravelModeIcon(mode)}
        </Marker>
      ) : (
        ""
      );
    });
  };

  processJourneyResponse(
    response,
    isKilometres,
    originLocation,
    destinationLocation
  ) {
    const {
      journeyOptions,
      request,
      journeyPlanId,
      departureTime,
      arrivalTime,
      boundingBox,
    } = response;

    journeyOptions.forEach((journey) => {
      journey.show = true;
      journey.active = false;
    });

    const publicTransportationOptions = {
      filterBus: !request.excludeModes.some(
        (mode) => mode.includes("Bus") || mode.includes("Coach")
      ),
      filterTram: !request.excludeModes.some((mode) => mode.includes("Tram")),
      filterTrain: !request.excludeModes.some((mode) => mode.includes("Rail")),
    };

    const journeyFilters = {
      ...request.additionalFilters,
      startLocation: {
        ...request.startLocation,
      },
      endLocation: {...request.endLocation},
      viaLocations: request.viaLocations,
      arrivalTime: request.arrivalTime,
      departureTime: request.departureTime,
    };

    // Set the origin and destination locations to use the returned location, not the input.
    const newOriginLocation = {
      location: journeyOptions[0].legs[0].startLocation,
      name: journeyOptions[0].legs[0].startLocation.description,
      ...originLocation,
    };

    const newDestinationLocation = {
      location:
        journeyOptions[0].legs[journeyOptions[0].legs.length - 1].endLocation,
      name: journeyOptions[0].legs[journeyOptions[0].legs.length - 1]
        .endLocation.description,
      ...destinationLocation,
    };

    safeLocalStorageService.setItem("latestJourneyPlanId", journeyPlanId);
    safeLocalStorageService.setItem(
      "latestJourneyOptionId",
      journeyOptions[0].id
    );

    this.setState(
      {
        originLocation: newOriginLocation,
        destinationLocation: newDestinationLocation,
        journeyPlanId: journeyPlanId,
        activeJourney: 0,
        journeys: response,
        activeJourneyLegs: journeyOptions[0]?.legs || [],
        showResults: true,
        showLoading: false,
        showInitialLoading: false,
        showLoadingJourneyMessages: false,
        showForm: false,
        departureTime,
        arrivalTime,
        // Don't set boundingBox here - let setViewportToJourney handle it
        startLocation: journeyFilters.startLocation,
        endLocation: journeyFilters.endLocation,
        showTravelPlan: true,
        searched: true,
        filters: {...journeyFilters, isKilometres},
        activeDestinationEvent: destinationLocation,
        publicTransportationOptions,
      },
      () => {
        // Set viewport to the first journey option with force reload for initial load
        this.setViewportToJourney(0, true);
      }
    );
  }

  _renderTravelModeIcon(param) {
    const icons = {
      Walk: Walk,
      Ferry: Ferry,
      CableCar: CableCar,
      Rail: Rail,
      Bus: Bus,
      Underground: Underground,
      Tram: Tram,
      ElectricVehicle: Drive,
      Drive: Drive,
      Park: Park,
      EvStation: EvStation,
      Flight: Flight,
      CycleDock: CycleDock,
      Cycle: Cycle,
      CycleStreetsQuietest: Cycle,
      CycleStreetsFastest: Cycle,
      CycleStreetsBalanced: Cycle,
      CycleStreetsDefault: Cycle,
    };

    const iconSrc = icons[param];
    if (iconSrc) {
      return (
        <img
          src={iconSrc}
          className={styles[param === "Flight" ? "Flight" : "Icon"]}
          alt={"Travel mode icon " + param.toLowerCase()}
        />
      );
    } else {
      // Return a black location marker for unknown travel modes
      return (
        <LocationOn
          fill="black"
          className={styles["LocationOn"]}
          alt="Location marker"
        />
      );
    }
  }

  updateStartEndLocation = (
    assistantPosition,
    requestorPosition,
    assistantPosDesc,
    requestorPosDesc
  ) => {
    if (
      !assistantPosition ||
      !assistantPosition.longitude ||
      !assistantPosition.latitude
    ) {
      alert(
        "Location Services are disabled, please enable location services to use this function"
      );
      return;
    }
    this.setJourneyPlanUpdated(
      assistantPosition,
      requestorPosition,
      assistantPosDesc,
      requestorPosDesc
    );
  };

  _renderActiveDestinationEvent = () => {
    if (
      !this.state.activeDestinationEvent ||
      !this.state.activeDestinationEvent?.eventId
    )
      return;

    return (
      <div>
        {this.state.markerPopup && (
          <MapMarkerPopup
            isVisGlLibrary={true}
            destinationEvent={this.state.activeDestinationEvent}
            travelPlanId={this.state.travelForecastId}
            updateCloseCallBack={this.updateCloseCallBack}
            setChargeWayPoint={this.setChargeWayPoint}
            setViewport={this.setViewport}
            selectedDateTime={
              this.state.selectedDateTime === null
                ? moment.parseZone().format("yyyy-MM-DD")
                : moment(this.state.selectedDateTime).format("yyyy-MM-DD")
            }
            destinationGroup={this.state.destinationGroup}
            forceShowPopup={
              this.state.clickedPreviousDestinationEvent?.id ===
              this.state.activeDestinationEvent?.id
            }
          />
        )}
      </div>
    );
  };

  _renderUserPosition = () => {
    if (!this.state.assistanceRequestData) return;
    const {firstName, lastName, email, userPositions} =
      this.state.assistanceRequestData;
    const {geoPosition, lastUpdated} =
      userPositions[userPositions.length - 1];
    const [longitudeRaw, latitudeRaw] = geoPosition.coordinates;
    const {
      lat: latitude,
      lng: longitude,
      valid,
    } = parseAndValidateLngLat(longitudeRaw, latitudeRaw);
    const displayRequestFrom =
      firstName && lastName ? `${firstName} ${lastName}` : email;
    const displayLastUpdated = moment
      .parseZone(lastUpdated)
      .format("DD/MM/YYYY HH:mm");
    var firstnamestring = "Find " + firstName;

    if (!geoPosition || !valid) return;

    return (
      <>
        <Marker
          latitude={latitude + 0.0005}
          longitude={longitude + 0.0005}
          offsetLeft={-20}
          offsetTop={-40}
        >
          <CurrentLocation colour="#0000FF" />
        </Marker>
        {this.state.showAssistantInformation && (
          <Popup
            anchor="bottom"
            tipSize={5}
            maxWidth={240}
            longitude={longitude + 0.0005}
            latitude={latitude + 0.0005}
            offsetLeft={-20}
            offsetTop={-40}
            closeButton={true}
            closeOnClick={true}
          >
            <div className={styles["pop-up-inner"]}>{displayRequestFrom}</div>
            <small>Last updated: {displayLastUpdated}</small>
            <br />
            <div className={styles["Button"]}>
              <div className={styles["button-container"]}>
                <button
                  type="button"
                  className={styles["popup-button"]}
                  onClick={() =>
                    this.updateStartEndLocation(
                      this.state.currentPosition,
                      geoPosition,
                      "Current Location",
                      firstName
                    )
                  }
                  onKeyPress={this.finish}
                >
                  <span className={styles["button-span"]}>
                    {firstnamestring}
                  </span>
                </button>
              </div>
            </div>
          </Popup>
        )}
      </>
    );
  };

  _renderActiveTrafficMarker = () => {
    return (
      <div>
        {this.state.markerTrafficPopup && (
          <MapMarkerTrafficPopup
            activeTrafficObject={this.state.activeTrafficObject}
            updateCloseCallBack={this.updateTrafficPopupCloseCallBack}
          />
        )}
      </div>
    );
  };

  _renderLoading = () => {
    const {showLoading, showInitialLoading, showLoadingJourneyMessages} =
      this.state;
    return (
      <>
        {showLoading && (
          <ErrorBoundary>
            <Loading fullscreen={true} />
          </ErrorBoundary>
        )}
        {showInitialLoading && <InitialLoadingMessages />}
        {showLoadingJourneyMessages && <JourneyLoadingMessages />}
      </>
    );
  };

  handleMapFocus = () => {
    this.setState({mapFocusActived: true});
  };

  handleMapBlur = () => {
    this.setState({mapFocusActived: false});
  };

  // Logic to handle scrolling in embedded versions of the app.
  handleTouchStart = (event) => {
    if (this.state.mapLocked) return;
    const isMobile = this.refs.Map?.clientWidth < MOBILE_VIEW_THRESHOLD;
    if (!isMobile) return;

    if (event?.points.length === 2) {
      this.reactMap.getMap().scrollZoom.enable();
      this.reactMap.getMap().dragPan.enable();
    }
  };

  handleTouchEnd = () => {
    const isMobile = this.refs.Map?.clientWidth < MOBILE_VIEW_THRESHOLD;
    if (isMobile) {
      this.reactMap.getMap().scrollZoom.disable();
      this.reactMap.getMap().dragPan.disable();
    }
  };

  handleUpdateMarkerOptions = () => {
    if (!this.state.destinationGroup.hasDiversions) {
      return;
    }
    let date =
      this.state.selectedDateTime === null
        ? moment.parseZone().format()
        : moment(this.state.selectedDateTime).format();

    let markerOptionsEndpoint = `markerOptionsWithGSI/${this.state.destinationGroup.shortCode
      }?dateTimeOffset=${encodeURIComponent(date)}`;
    restServiceGet(this.props.apiToken, markerOptionsEndpoint)
      .then((response) => {
        if (response.data) {
          const prevState = this.state;
          this.setState(
            {
              markerOptions: response.data,
            },
            () => {
              if (this.state.markerOptions !== undefined) {
                for (
                  let index = 0;
                  index < this.state.markerOptions.length;
                  index++
                ) {
                  if (
                    (this.state.markerOptions[index].initialDisplay !==
                      undefined &&
                      this.state.markerOptions[index].initialDisplay ===
                      true) ||
                    (prevState.markerOptions &&
                      prevState.markerOptions[index] &&
                      prevState.markerOptions[index].isFocused)
                  ) {
                    this.markerOptionsAction(index);
                  }
                }
              }
            }
          );
        }
      })
      .catch((error) => {
        console.log("Error while getting the marker options: " + error);
      });
  };

  getOktaId = () => {
    // Try injected headers first
    if (typeof window.__HEADERS__ === "object" && window.__HEADERS__.oktaId) {
      return window.__HEADERS__.oktaId;
    }
    // Fallback to cookie
    const match = document.cookie.match(/(^|;\s*)oktaId=([^;]*)/);
    if (match) return decodeURIComponent(match[2]);
    return "";
  };

  _renderMap = () => {
    const {
      showInitialLoading,
      showLoadingJourneyMessages,
      showResults,
      showForm,
      viewport,
      destinationEvents,
      showConfirmation,
      isMultiDestination,
      customMapURL,
      mapNotReadyToRender,
      markerOptions,
      errorMapLoad,
      width,
      journeys,
      activeJourney,
      clusteringEnabled,
      singleNonMDDestinationEvent,
      mapBounds,
    } = this.state;

    const changeOptions = {duration: 1000};

    // Force MapTiler for all maps - ignore Mapbox URLs from customMapURL
    let mapStylePath = MAPTILER_PATH_WITH_TOKEN;
    if (customMapURL && !customMapURL.includes("mapbox://")) {
      // Only use customMapURL if it's not a Mapbox URL
      mapStylePath = customMapURL;
    }

    const showButton = showResults && activeJourney !== null;

    mapService.validateMapPath(mapStylePath, (validPath) => {
      if (mapStylePath !== validPath && !validPath.includes("mapbox://")) {
        // Minimal fix: pause Source/Layer rendering while the style reloads.
        // onLoad will set styleLoaded back to true when the new style is ready.
        // Only update if validPath is not a Mapbox URL
        this.setState({customMapURL: validPath, styleLoaded: false});
      }
    });

    const isMobile = this.refs.Map?.clientWidth < MOBILE_VIEW_THRESHOLD;

    return (
      !errorMapLoad &&
      !mapNotReadyToRender &&
      !showConfirmation &&
      !showInitialLoading &&
      !showLoadingJourneyMessages &&
      ((showForm && width > 600) || !showForm) && (
        <>
          <div
            ref="JourneyMap"
            className={
              (this.state.showResults && this.state.journeys) ||
                this.state.showForm
                ? styles["JourneyMapWrapper"]
                : styles["MapWrapper"]
            }
            aria-hidden="true"
            tabIndex="-1"
          >
            <ThemeContext.Consumer>
              {(theme) => {
                const isJourneyLayoutDesktop =
                  ((showResults && journeys) || showForm) &&
                  width > 600 &&
                  !isMobile;
                const mapInlineStyle = isJourneyLayoutDesktop
                  ? {}
                  : {
                    top:
                      this.state.headerMapVerticalOffset && width > 600
                        ? "44px"
                        : "0px",
                    height: theme?.hideClientElements?.includes("hideFooter")
                      ? "100%"
                      : "100%",
                  };
                return (
                  <ReactMapGL
                    mapLib={maplibregl}
                    onTouchStart={this.handleTouchStart}
                    onTouchEnd={this.handleTouchEnd}
                    cooperativeGestures={isMobile}
                    key={this.state.updateMap}
                    onFocus={this.handleMapFocus}
                    onBlur={this.handleMapBlur}
                    mapStyle={mapStylePath}
                    ref={(reactMap) => (this.reactMap = reactMap)}
                    onLoad={() => this.setState({styleLoaded: true})}
                    onZoomEnd={() => {
                      // Force re-render when zoom ends so ClusterHandler recalculates clusters
                      this.forceUpdate();
                    }}
                    className={
                      (this.state.showResults && this.state.journeys) ||
                        this.state.showForm
                        ? styles["JourneyMap"]
                        : styles["Map"]
                    }
                    initialViewState={{
                      latitude: viewport.latitude,
                      longitude: viewport.longitude,
                      zoom: viewport.zoom,
                      bearing: viewport.bearing || 0,
                      pitch: viewport.pitch || 0,
                    }}
                    scrollZoom={!this.state.mapLocked && !isMobile}
                    dragPan={!this.state.mapLocked && !isMobile}
                    style={mapInlineStyle}
                  >
                    {(() => {
                      const canAddSources = this.state.styleLoaded;
                      return (
                        ((showForm && width > 600) ||
                          (showResults && journeys)) && (
                          <>
                            {canAddSources && this._renderJourneyPolylines()}
                            {canAddSources && this._renderActivePolyline()}
                            {this._renderPolylineIcons()}
                            {this._renderSelectedLocations()}
                            {this._renderUserPosition()}
                          </>
                        )
                      );
                    })()}
                    {this.state.showPolyPopUp && this._renderPolylinePopUp()}
                    {(() => {
                      const canAddSources = this.state.styleLoaded;
                      return canAddSources && this._renderPolylines();
                    })()}
                    {this._renderCurrentLocation()}
                    {this._renderActiveDestinationEvent()}
                    {this._renderActiveTrafficMarker()}
                    {this._renderTrafficData()}
                    {this._renderViewportMarker()}
                    <MarkerGroups
                      restServicePost={restServicePost}
                      apiToken={this.props.apiToken}
                      queryString={this.props.queryString}
                      showPrimaryGroup={!showResults && !showForm}
                      primaryGroupShortCode={
                        this.state.destinationGroupShortCode
                      }
                      primaryGroupDestinationEvents={destinationEvents}
                      isMultiDestination={isMultiDestination}
                      setActiveDestinationEventSelectedOnMap={
                        this.setActiveDestinationEventSelectedOnMap
                      }
                      togglePolyPopUp={this.togglePolyPopUp}
                      singleNonMDDestinationEvent={singleNonMDDestinationEvent}
                      clusteringEnabled={clusteringEnabled}
                      onClickCluster={this.onClickCluster}
                      markerOptions={markerOptions}
                      zoom={viewport.zoom}
                      mapBounds={mapBounds}
                      enableSources={this.state.styleLoaded}
                    />
                  </ReactMapGL>
                );
              }}
            </ThemeContext.Consumer>
          </div>
          <div
            className={`${styles["right-side-bar"]} ${showButton ? styles["right-side-bar-show-travel"] : ""
              }`}
          >
            <div
              role="region"
              className={styles["map-lock"]}
            >
              {isMobile ? (
                ""
              ) : (
                <img
                  data-cy={"lockMapButton"}
                  title={
                    this.state.mapLocked
                      ? "Unlock to move or zoom map"
                      : "Lock map to enable page scrolling"
                  }
                  tabIndex="0"
                  role="button"
                  src={this.state.mapLocked ? mapLockImg : mapUnlockImg}
                  alt={
                    this.state.mapLocked
                      ? "Unlock to move or zoom map"
                      : "Lock map to enable page scrolling"
                  }
                  width="46px"
                  height="46px"
                  style={{
                    marginTop: "5px",
                  }}
                  onClick={this.lockUnlockMap}
                />
              )}
              <img
                title={"Show on Map"}
                data-cy={"mapSettings"}
                tabIndex="0"
                role="button"
                src={
                  this.state.markerOptions.find(
                    (markerOption) => markerOption.isFocused
                  )
                    ? settingsActive
                    : settingsInactive
                }
                alt={"Map Settings button"}
                width="46px"
                height="46px"
                style={{
                  marginTop: "5px",
                }}
                onClick={this.toggleMarkerModal}
              />
              <img
                title={"mapCloseToggle"}
                tabIndex="0"
                role="button"
                src={this.state.fullscreen ? mapClose : mapExpand}
                alt="Toggle fullscreen"
                width="46px"
                height="46px"
                className={styles["fullscreen-button"]}
                onClick={this.toggleFullscreen}
              />
            </div>
          </div>
        </>
      )
    );
  };

  _renderMenu = () => {
    const {menu, organisation} = this.state;
    return (
      menu && (
        <Menu
          organisation={organisation}
          token={this.props.apiToken}
          showProfile={this.resetToggleProfile}
          showMenu={this.toggleMenu}
          thirdPartyAuthenticated={this.state.thirdPartyAuthenticated}
          auth={this.props.auth}
          handleLoginOperation={this.handleLoginOperation}
        />
      )
    );
  };

  _renderDisruptionsModal = () => {
    const {displayDisruptionsModal, disruptionMessages} = this.state;
    return (
      displayDisruptionsModal && (
        <DisruptionsModal
          toggleDisruptionsModal={this.toggleDisruptionsModal}
          disruptionsMessages={disruptionMessages}
          isUserWayActive={this.state.isUserWayActive}
          activeModal={this.state.activeModal}
          setActiveModal={this.setActiveModal}
        />
      )
    );
  };

  _renderProfile = () => {
    const {profile} = this.state;
    return (
      profile && (
        <Profile
          token={this.props.apiToken}
          getprofilefilter={this.getProfileFilters}
          profilefilters={this.state.profilefilter}
          profileId={this.state.profileId}
          saveprofilefilter={this.saveEditProfileInfo}
          toggleProfile={this.toggleProfile}
          toggleRequestAssistance={this.useCurrentLocation}
          previousTravelPlans={this.state.previousTravelPlans}
          isTravelProfileItinerary={this.state.isTravelProfileItinerary}
          pastTravelPlans={this.state.pastTravelPlans}
          journeyOptions={this.state.journeys.journeyOptions}
          getPreviousTravelPlan={this.getPreviousTravelPlan}
          thirdPartyAuthenticated={this.state.thirdPartyAuthenticated}
          auth={this.props.auth}
          logout={this.logout}
          travelPlans={this.getFilterUserTravelPlans}
          destinationGroup={this.state.destinationGroupShortCode}
          assistanceSettings={this.state.assistanceSettings}
          destinationGroupAssistanceSettings={
            this.state.destinationGroupAssistanceSettings
          }
          createUserProfile={this.createUserProfile}
          defaultFrom={this.state.defaultFrom}
          defaultTo={this.state.defaultTo}
          travelForecast={this.state.travelForecast}
          editProfile={this.state.editProfile}
          toggleEditProfile={this.toggleEditProfile}
          loginOrSaveTravelForecast={this.loginOrSaveTravelForecast}
        />
      )
    );
  };

  _renderRequestAssistance = () => {
    const {requestAssistance, travelForecastId, showPendingAssistance} =
      this.state;
    return (
      requestAssistance && (
        <RequestAssistance
          showRequestAssistance={this.toggleRequestAssistance}
          toggleConfirmation={this.toggleConfirmation}
          toggleAssistanceProfileOnConfirmation={
            this.toggleAssistanceProfileOnConfirmation
          }
          destinationGroup={this.state.destinationGroupShortCode}
          assistanceSettings={this.state.assistanceSettings}
          destinationGroupAssistanceSettings={
            this.state.destinationGroupAssistanceSettings
          }
          travelForecastId={travelForecastId}
          apiToken={this.props.apiToken}
          showPendingAssistance={showPendingAssistance}
          currentPosition={this.state.currentPosition}
        />
      )
    );
  };

  _renderSharing = () => {
    const {
      sharing,
      destinationGroupName,
      activeDestinationEvent,
      journeyPlanId,
      selectedJourneyOption,
      destinationGroup,
    } = this.state;

    return (
      sharing && (
        <Sharing
          initialUrlExtension={this.props.initialUrlExtension}
          eventName={destinationGroupName}
          destinationGroup={destinationGroup?.shortCode}
          journeyPlanId={journeyPlanId}
          journeyOptionId={selectedJourneyOption?.Id}
          image={activeDestinationEvent?.image}
          toggleSharepage={this.toggleSharing}
        />
      )
    );
  };

  render() {
    return (
      <div>
        <div
          className={styles["Event"]}
          ref="Map"
        >
          {this._renderEditJourney()}
          {this._renderMap()}
          {this._renderJourneyCollection()}
          {this._renderJourneyCollectionBottomSheet()}
          {this._renderErrorMessage()}
          {this._renderAddNotification()}
          {this._renderLoading()}
          {this._renderConfirmation()}
          {this._renderSharing()}
          {this._renderProfile()}
          {this._renderDisruptionsModal()}
          {this._renderMenu()}
          {this._renderRequestAssistance()}
          {this._renderCrossSiteWarning()}
          {this._renderThirdPartyPopup()}
          {this._renderInfoPopup()}
          {this._renderSessionManagement()}
          <ThemeContext.Consumer>
            {(theme) => (
              <div>
                {!theme?.hideClientElements?.includes("hideFooter") ? (
                  <Footer
                    organisation={this.state.organisation}
                    toggleSharepage={this.toggleSharing}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </ThemeContext.Consumer>
        </div>
      </div>
    );
  }
}

export default withRouter(Event);
